{
  "settings": {
    "calendar": {
      "calendar_settings": "Calendar settings",
      "settings": "Settings",
      "select_calendar_type": "Select calendar type",
      "add_new_calendar_group": "Add new calendar group",
      "add_new_equipment": "Add new equipment",
      "new_calendar": "New calendar",
      "calendar_group_description": "Use calendar groups to effectively organize and group multiple calendars together.",
      "group": "Group",
      "manage_your_calendars_and_groups": "Manage your calendars and groups",
      "groups": "Groups",
      "create_group": "Create group",
      "create_calendar": "Create calendar",
      "calendar_name": "Calendar name",
      "group_duration": "Group duration",
      "calendar_type": "Type",
      "action": "Action",
      "round_robin": "Round robin",
      "event": "Event",
      "group_name": "Group name",
      "room_name": "Room name",
      "group_description": "Group description",
      "calendar_url": "Calendar URL",
      "calendars": "Calendars",
      "date_updated": "Date updated",
      "status": "Status",
      "action_dropdown": "Action dropdown",
      "calendar_list": "Services associated to",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "copy_embed_code": "Copy embed code",
      "copy_permanent_link": "Copy permanent link",
      "copy_new_slug_link": "Copy scheduling link",
      "copy_scheduling_link": "Copy scheduling link (legacy deprecated)",
      "deactivate_calendar": "Deactivate calendar",
      "move_to_group": "Move to group",
      "delete_calendar": "Delete calendar",
      "delete_group": "Delete",
      "delete_this_group": "Delete this group",
      "activate_calendar": "Activate calendar",
      "duration": "Duration",
      "all": "All",
      "draft": "Draft",
      "inactive": "Inactive",
      "active": "Active",
      "actions": "Actions",
      "rearrange_calendars": "Rearrange calendars",
      "deactivate_all_calendars_in_group": "Deactivate all calendars in group",
      "activate_all_calendars_in_group": "Activate all calendars in group",
      "no_groups_found": "Your search did not match any calendar groups.",
      "no_groups_in_location": "Groups organize your calendars like folders. Add calendars to a group and share a single scheduling link, letting bookers choose from multiple calendars.",
      "no_calendars_found": "Get started using calendar by creating new calendar.",
      "no_calendars_found_search": "Your search did not match any calendars.",
      "delete_calendar_message": "You're about to delete calendar. When you hit delete it will also delete all its appointments.",
      "delete_calendar_message_title": "Delete this calendar?",
      "duplicate_calendar_message": "You're about to duplicate calendar. This will create a new calendar with the same settings as the selected calendar.",
      "duplicate_calendar_message_title": "Duplicate this calendar?",
      "no_calendars_found_title": "No calendars found",
      "no_groups_in_location_title": "No groups found",
      "delete_group_confirmation_title": "Delete this group?",
      "delete_group_confirmation": "Are you sure you wish to delete the selected group?",
      "delete_group_confirmation_checkbox_title": "Delete associated calendars and appointments",
      "delete_group_confirmation_checkbox_description": "Selecting this option will also delete the calendars in this group, along with all appointments in those calendars.",
      "group_status_message_title": "{status} group & all associated calendars?",
      "calendar_status_message_title": "{status} this calendar?",
      "calendar_status_message": "You're about to {status} calendar.",
      "group_status_active_message": "Are you sure you want to activate this group? All calendars within the group will also be activated and available for booking.",
      "group_status_inactive_message": "Are you sure you want to deactivate this group? All calendars within the group will also be deactivated and available for booking.",
      "coming_soon": "Coming soon",
      "select": "Select",
      "15mins": "15mins",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create",
      "select_calendar_group": "Select calendar group",
      "move_calendar_confirmation": "The legacy link will stop working once you proceed with this change. Confirm by selecting the checkbox.",
      "previously_called_unassigned": " (Previously called as unassigned)",
      "scheduling_type": "Choose calendar type",
      "scheduling_type_description": "Select a calendar type to set up your calendar and customize how appointments are scheduled.",
      "service_menu_name": "Service menu name",
      "template": "Template",
      "select_template": "Select template",
      "group_url": "Group URL",
      "template_description": "You now have the choice to select either the Classic or Neo templates for the Group view.",
      "rooms": "Rooms",
      "rooms_name": "Name",
      "rooms_description": "Description",
      "rooms_modal_description": "Add or edit room.",
      "rooms_capacity": "Total capacity",
      "no_rooms_in_location_title": "No rooms found",
      "no_rooms_in_location": "No rooms found in this location",
      "no_equipments_in_location": "No equipment found in this location",
      "equipments": "Equipment",
      "equipment_name": "Name",
      "equipment_name_search": "Equipment name",
      "equipment_description": "Description",
      "equipment_modal_description": "Add or edit an equipment.",
      "add_equipment": "Add/edit equipment",
      "add_room": "Add/edit room",
      "equipment_quantity": "Total quantity",
      "equipment_outOfService": "Out of service quantity",
      "no_equipments_in_location_title": "No equipment found",
      "delete_this_equipment": "Delete this equipment",
      "delete_this_rooms": "Delete this room",
      "delete_equipment_confirmation": "Are you sure, you want to delete this equipment? This will be removed from all the linked calendars also.",
      "delete_rooms_confirmation": "Are you sure, you want to delete this room? This will be removed from all the linked calendars also.",
      "add_new_calendar_equipments": "Add new equipment",
      "no_equipments_found": "Your search did not match any equipment.",
      "no_rooms_found": "Your search did not match any rooms.",
      "add_new_calendar_rooms": "Add new room",
      "rooms_disable": "Disable room",
      "equipments_disable": "Disable equipment",
      "equipments_activate": "Activate equipment",
      "rooms_activate": "Activate room",
      "create_equipments": "Create equipment",
      "create_rooms": "Create room",
      "select_calendar_rooms_title": "Select calendar",
      "select_calendar_rooms_description": "You can select multiple calendars to associate with rooms.",
      "select_calendar_equipments_title": "Select calendar",
      "select_calendar_equipments_description": "You can select one calendar to associate with the equipment.",
      "disable_equipment_title": "{status} equipment",
      "disable_room_title": "{status} room",
      "equipments_status_message": "Are you sure you want to {status} this equipment?",
      "rooms_status_message": "Are you sure you want to {status} this room?",
      "calendar_resource_disclaimer": "This might affect the availability on associated service calendars.",
      "equipment_disclaimer": "Note: Enabling the equipment later will automatically reconnect it to calendars it's associated with",
      "room_disclaimer": "Note: Enabling the room later will automatically reconnect it to calendars it's associated with",
      "equipment_tab_name": "Equipment",
      "rooms_tab_name": "Rooms",
      "manage_your_rooms": "Manage rooms for your business here",
      "manage_your_equipments": "Manage equipment for your business here",
      "select_service_calendar_description_equipments": "You can select multiple service calendars to associate with equipment.",
      "select_service_calendar_description_rooms": "You can select multiple service calendars to associate with rooms.",
      "service_menus": "Service menu",
      "manage_your_calendars_groups_and_service_menus": "Manage your calendars, groups and service menu",
      "new_service_menu": "Create service menu",
      "deactivate_service_menu": "Deactivate service menu",
      "delete_service_menu": "Delete this service menu",
      "delete_service_menu_confirmation": "Are you sure you want to delete this service menu ?",
      "service_menu_status_message_title": "{status} this service menu?",
      "service_menu_status_message": "You're about to {status} service menu.",
      "no_service_menus_in_location_title": "Create your customized service menu",
      "add_new_service_menu": "Add new service menu",
      "no_service_menus_in_location": "Start by creating a new service menu and adding Groups to it",
      "no_service_menu_found": "No service menu found",
      "no_service_menu_found_desc": "Your search did not match any service menus.",
      "apply": "Apply",
      "troubleshoot_calendar": "Troubleshoot calendar",
      "round_robin_booking": "Round robin",
      "round_robin_description": "Distributes appointments among team members in a rotating order.",
      "round_robin_example": "E.g.: Sales calls, onboarding sessions.",
      "unassigned_booking": "Event calendar",
      "unassigned_description": "For scheduling physical events with no host association.",
      "unassigned_example": "E.g.: Conferences, public seminars, expos.",
      "event_booking_alert_title": "Important",
      "event_booking_alert_message": "This calendar type has key differences.",
      "event_booking_learn_more": "Learn more",
      "event_booking_tooltip_title": "Things to Know:",
      "event_booking_tooltip_content": "• Event calendars don’t have users, so meetings can’t be assigned to a user.\n• Because no user is assigned, dynamic meeting link tools aren’t supported (Zoom, Google Meet, Microsoft Teams). To use online meetings, copy a static conferencing link from any tool and paste it into the meeting location.\n• Because no user is assigned, meetings don’t sync to a user’s calendar from Calendar settings → Connections. Conflict calendars added there aren’t considered.\n• Meetings sync only to the calendar selected under External Sync for this calendar.\n• Events are fetched from and pushed only to the selected external calendar.\n• Only one Google calendar can be connected using external sync.",
      "class_booking": "Class booking",
      "class_booking_description": "One host meets with multiple participants.",
      "class_booking_example": "E.g.: Webinars, group training, online classes.",
      "collective_booking": "Collective booking",
      "collective_booking_description": "Multiple hosts meet with one participant.",
      "collective_booking_example": "E.g.: Panel interviews, committee reviews.",
      "service_booking": "Service booking",
      "service_booking_description": "Seamless scheduling for service based businesses.",
      "service_booking_example": "E.g.: Spa appointments, repair services, consultations.",
      "personal_booking": "Personal booking",
      "personal_booking_description": "Schedules one-on-one meetings with a specific team member.",
      "personal_booking_example": "E.g.: Client meetings, private consultations.",
      "personal": "Personal",
      "explore_more_types": "Explore more types",
      "no_calendars_added": "No calendars yet – set one up!",
      "no_calendars_added_description": "Create your first calendar to start scheduling effortlessly.",
      "no_groups_added": "No groups yet – start organizing!",
      "no_calendars_yet": "No calendars yet",
      "no_groups_yet": "No groups yet",
      "no_calendars_access": "No calendars have been created yet. Once a calendar is created, it will appear here. You do not have access to create a calendar—please contact your admin if needed.",
      "no_groups_access": "No groups have been set up yet. Once a group is created, it will appear here. You do not have access to create a group—please contact your admin if needed.",
      "no_groups_added_description": "Use groups to keep your calendars structured. Add calendars to a group and share a single group scheduling link for easy booking.",
      "group_success_message": "Group is successfully created. You can now add calendars to this group.",
      "choose_calendars": "Choose calendars",
      "do_it_later": "I'll do it later",
      "add_calendars_to_group": "Add calendars to the group",
      "select_calendars_to_add": "Please select all the calendars you want to add to the group {name}",
      "add_calendars": "Add calendar(s)",
      "continue": "Continue",
      "conflicting_calendars": "Conflicting calendars",
      "conflicting_calendars_description": "The following calendars are already part of other groups. Do you want to move them to your new group, <b>{name}</b>?",
      "group_associated_with": "Current group",
      "move_calendar_consent": "I allow moving these calendars to the new group.",
      "calendars_moved_successfully": "All the selected calendars have been successfully moved to {name}.",
      "new_group": "New group",
      "back": "Back",
      "share_otl": "Share your availability every time with a unique link that expires after a booking, ensuring controlled access.",
      "copied_to_clipboard": "Copied to clipboard",
      "generate_link": "Generate new link",
      "generate_link_error": "Couldn't generate one time link. Please try again",
      "share_schedule_link": " The scheduling link is determined by the slug. Adjust the slug, and the scheduling link automatically adapts to the modification.",
      "share_permanent_link": "Ideal for funnels, website redirects, or ads, the permanent link remains constant, unaffected by slug changes.",
      "copy": "Copy",
      "share_embed_code": "Place this code in your HTML where you want your {embedType} widget to appear.",
      "scheduling_link": "Scheduling link",
      "permanent_link": "Permanent link",
      "one_time_link": "One time link",
      "embed_code": "Embed code",
      "loading": "Loading...",
      "share_group": "Share group",
      "edit_group": "Edit group",
      "more_options": "More options",
      "share_calendar": "Share calendar",
      "edit_calendar": "Edit calendar",
      "troubleshoot_calendar_link": "Troubleshoot calendar",
      "calendar_config_success": "You have successfully configured your personal/team calendar",
      "close": " Close",
      "added_calendars": "Added calendar(s)",
      "select_calendars": "Select calendar(s)",
      "settings_confirmation": "To proceed, please confirm these changes.",
      "consent_checkbox_title": "I understand and accept these changes.",
      "confirm": "Confirm",
      "create_group_access_disabled": "You don't have permission to create a group. Contact your admin for access.",
      "create_calendar_access_disabled": "You don't have permission to create a calendar. Contact your admin for access.",
      "preview_booking_widget": "Preview booking widget",
      "share_service_menu": "Share service menu",
      "back_message": "Back to calendars list",
      "service_calendars": "Service calendars",
      "owned_by": "Owned by",
      "owned_by_anyone": "Anyone",
      "owned_by_me": "Me",
      "all_groups": "All groups",
      "all_calendars": "All calendars",
      "not_grouped": "Not grouped",
      "delete_group_desc": "Are you sure you want to delete this group? This will also delete all the calendars associated with this group.",
      "calendar_listing_title": "Calendar listing",
      "calendar_group_name": "Calendar/group name",
      "success": "Success",
      "my_calendar": "my-calendar",
      "service_calendar_description": "Seamless scheduling for service businesses."
    },
    "preferences": {
      "preferences": "Preferences",
      "my_preferences": "My preference",
      "account_preferences": "Account preference",
      "user_preferences": "User preferences",
      "set_preferences": "Set your preferences for your account.",
      "scheduling_options": "Scheduling options",
      "meeting_location": "Meeting location",
      "zoom": "Zoom",
      "save_preferences": "Save preferences",
      "in_app_preferences": "In app preferences",
      "set_start_day": "Set preferences like start day for the app",
      "view_options": "View options",
      "services": "Services",
      "feature_toggle_aria": "Feature toggle",
      "week_starts_on": "Week starts on",
      "sunday": "Sunday",
      "widget_preferences": "Widget preferences",
      "set_widget_language": "Set preferences like language for widget",
      "language_and_region": "Language and region",
      "language": "Language",
      "english": "English",
      "time_format": "Time format",
      "time_format_value": "1:30 PM",
      "monday": "Monday",
      "custom_meeting_location": "Custom meeting location",
      "view_appointments_in_1": "View appointments in",
      "timezone_uses_details_1": "We’ll use this timezone to display appointment times throughout the app and in your appointment-related emails — just for you. It won’t affect your availability or how others book with you.",
      "business_timezones_1": "Business timezone",
      "business_timezones_tooltip_1": "Note: Choosing this option ensures that your viewing preference aligns with the selected business timezone. If the business timezone changes, your viewing timezone will automatically adjust to match.",
      "recommended_timezones": "Recommended timezones",
      "all_timezones": "All timezones"
    },
    "availability": {
      "availability": "Availability",
      "my_availability": "My availability",
      "my_availability_and_booking_rules": "Availability schedule",
      "my_availability_and_booking_rules_description": "Set when meetings can be booked based on staff availability.",
      "account_availability": "Account availability",
      "timezone": "Timezone",
      "working_hours": "Working hours",
      "set_recurring_hours": "Set your recurring working hours for meeting",
      "select_one": "Select one",
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "widget_preferences": "Widget preferences",
      "set_widget_language": "Set preferences like language for widget",
      "language_and_region": "Language and region",
      "language": "Language",
      "english": "English",
      "copy_to_all": "Copy to all",
      "save_availability": "Save availability",
      "add_time": "Add time",
      "to": "To",
      "select_time": "Select time",
      "add_user": "Add user",
      "accessRestricted": {
        "header": "Access restricted",
        "message": "You're not a part of this account. To get access, add yourself to this account via Agency Settings > Teams > Edit Team Member, and assign the account under 'Roles & permissions'.",
        "contact_admin": "This page is only accessible to admins. Please contact your admin for assistance.",
        "button_text": "Go to Agency Settings."
      },
      "schedule": {
        "edit_schedule": "Edit schedule",
        "schedule_name": "Schedule name",
        "schedule_name_required": "The Schedule name is required",
        "timezone": "Timezone",
        "timezone_placeholder": "Select one",
        "start_time": "Start time",
        "end_time": "End time",
        "add_availability_hour": "Add availability hour",
        "remove_availability_hour": "Remove availability hour",
        "unavailable": "Unavailable",
        "schedule_created": "Schedule created successfully",
        "schedule_updated": "Schedule updated successfully",
        "calendars_selected": "{count} calendar",
        "calendars_selected_multiple": "{count} calendars",
        "select_users_placeholder": "Search users",
        "edit_default_schedule": "Edit this schedule",
        "customize_event_type_schedule": "Customize schedule for this calendar only",
        "multi_user_description": "Update availability for <b>{count} selected users</b> -  {calendar}",
        "bulk_edit_warning_banner": "Bulk edit enabled. Changes will overwrite the existing schedules for all selected users.",
        "bulk_edit_slot_applies_to_all": "Selected slot will apply to all selected users.",
        "bulk_edit_slot_applies_to_selected": "Selected slot will apply to {count} selected user(s).",
        "bulk_edit_applies_to_all": "Changes will apply to all {count} selected users.",
        "bulk_edit_weekly_hours": "Bulk edit weekly hours",
        "bulk_edit_weekly_hours_title": "Bulk edit weekly hours",
        "bulk_edit_weekly_hours_desc": "This will replace the weekly hours for all users listed below.",
        "edit_now": "Edit now",
        "bulk_edit": "Bulk edit",
        "choose_days_weekly_hours": "Choose the day(s) to set weekly hours",
        "assign_to": "Assign to:",
        "configure_weekly_hours": "Configure weekly hours",
        "selected_users": "Selected users:",
        "bulk_edit_select_users": "Select users to apply",
        "bulk_edit_select_users_placeholder": "Select team members...",
        "bulk_edit_select_at_least_one": "Please select at least one user.",
        "bulk_edit_editing_for": "Editing for:",
        "bulk_edit_applies_to": "Applies to:",
        "bulk_edit_user_count": "{count} user",
        "bulk_edit_users_count": "{count} users",
        "show_less": "Show less",
        "more": "more",
        "confirm_delete": "Confirm delete",
        "confirm": "Confirm",
        "delete_user_date_confirm": "Are you sure you want to delete the date-specific hours for <b>{userName}</b> on <b>{date}</b>?",
        "delete_date_confirm": "Are you sure you want to delete the date-specific hours for all users on <b>{date}</b>?",
        "selected_calendar": "selected calendar",
        "edit_schedule_alert": "Updates made here will apply to",
        "schedule": "Schedule",
        "no_availability": "No availability",
        "date_specific_hours_show_more": "more",
        "date_specific_hours_show_less": "less",
        "date_specific_hours_recurring_meetings_enabled": "Date-specific hours can't be added because this schedule is linked to a calendar with recurring meetings enabled. To proceed, please disable recurring meetings.",
        "recurring_incompatible_with_date_hours": "Recurring meetings can't be enabled because the user's schedule has date-specific hours, which is incompatible.",
        "incompatible_schedule_with_recurring": "{user} schedule contains date-specific hours, which is incompatible with recurring meetings.",
        "incompatible_schedule_with_recurring_calendar": "Schedule contains date-specific hours, which is incompatible with recurring meetings.",
        "recurring_meetings_enabled_multi_user": "Recurring meetings are not supported for calendars with multiple team members or when a team member has date-specific hours added to their schedule.",
        "weekdays": "Weekdays, {timeRange}",
        "weekdays_hours_vary": "Weekdays, Hours vary",
        "weekend": "Weekend, {timeRange}",
        "weekend_hours_vary": "Weekend, Hours vary",
        "days_hours_vary": "{days}, Hours vary",
        "date_specific_hours_tab_name": "Date-specific hours",
        "date_specific_hours": "{count} date-specific hours",
        "date_specific_hours_1": "1 date-specific hour",
        "weekly_hours": "Weekly hours",
        "custom_schedule": "Custom schedule",
        "select_schedule": "Select a schedule",
        "no_schedules_found": "No schedules found",
        "untitled": "Untitled",
        "error_updating_schedules": "Error while updating schedules",
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "custom": "Custom",
        "this_is_required": "This is required",
        "search": "Search",
        "edit_hours": "Edit hours",
        "schedule_name_duplicate": "A schedule with this name already exists",
        "delete_schedule_title": "Delete '{scheduleName}' Schedule?",
        "delete_schedule_description": "This action can not be undone. Are you sure you wish to proceed?",
        "delete_schedule_negative_text": "Cancel",
        "delete_schedule_positive_text": "Yes, delete.",
        "active_on": "Active on",
        "weekly_working_hours": "Weekly working hours",
        "weekly_working_hours_subtext": "Choose days and timings you work on",
        "copy_availability_hour": "Copy availability hour",
        "mins": "Minutes",
        "hours": "Hours",
        "save_weekly_hours": "Save weekly hours",
        "save_date_specific_hours": "Save date-specific hours",
        "update_weekly_hours_for_users": "Update weekly hours for {count} users",
        "set_date_specific_hours_for_users": "Set date-specific hours for {count} users",
        "set_date_specific_hours_for_user": "Set date-specific hours"
      }
    },
    "connections": {
      "connections": "Connections",
      "connect": "connect",
      "conferencing": "Conferencing",
      "my_connections": "My connections",
      "account_connections": "Account connections",
      "connection_preferences": "Connection preferences",
      "manage_calendars_conferencing_channels": "Manage Calendars and Conferencing channels",
      "main_integration_calendar": "Main integration calendar",
      "event_integration_calendar": "Events created on a system calendar that you are a part of will also be created on this integrated calendar",
      "2way_sync": "2-Way Sync: Create System Events from events booked on the main integrated calendar",
      "calendars": "Calendars",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Check for conflicts",
      "choose_accounts_to_connect": "Choose which accounts you wish to connect",
      "payments": "Payments",
      "stripe": "Stripe",
      "ads": "Ads",
      "local_service_ads": "Local service ads",
      "fire_workflow": "Fire workflow triggers for events booked via 2-way sync",
      "connect_google_outlook": "Please connect your Google/Outlook/iCloud account to be able to pick primary calendar.",
      "execute_automation": "Execute automation",
      "save": "Save",
      "lsa": "Local service ads",
      "no_write_access": "You do not write access to this calendar",
      "connection_remove_confirmation": "You're about to remove this integration",
      "active": "Active",
      "icloud": {
        "title": "iCloud Integration",
        "description": "Two-factor authentication and an app-specific password are required to connect your account.",
        "email": "iCloud Email Address",
        "password": "iCloud Password",
        "connect": "Connect",
        "cancel": "Cancel"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Select a contact",
    "start_time": "Start time",
    "unassigned": "Unassigned",
    "end_time": "End time",
    "search_by_name_email_phone_or_company": "Search by name, email, phone or company",
    "add_new": "Add new",
    "pick_from_available_contacts": "Or pick from available contacts",
    "book_appointment": "Book appointment",
    "add_blocked_off_time": "Add blocked off time",
    "recommended_timezones": "Recommended timezones",
    "all_timezones": "All timezones",
    "calendar": "Calendar",
    "repeat": "Repeat",
    "date_and_time": "Date and time",
    "close": "Close",
    "team_member": "Team member",
    "recurring_booking": "Recurring booking",
    "one_slot_booking": "One slot booking",
    "event_type": "Event type",
    "occurrences_booked": "occurrences will be booked",
    "repeats": "Repeats",
    "booking_details": "Booking details",
    "showing_slots_in_this_timezone": "Showing slots in this timezone:",
    "update_contact_tz": "Also update contact timezone to",
    "date": "Date",
    "slot": "Slot",
    "calendar_default": "Calendar default",
    "custom": "Custom",
    "meeting_notes": "(eg) Meeting notes for our upcoming appointment",
    "out_of_office": "(eg) Out of office for the week!",
    "standard": "Default",
    "appointment_title": "Appointment title",
    "event_title": "Event title",
    "appt_with_bob": "(eg) Appointment with Bob",
    "vacation": "(eg) Vacation",
    "show_notes": "Show notes",
    "hide_notes": "Hide notes",
    "additional_preferences": "Additional preferences",
    "meeting_location": "Meeting location",
    "appointment_status": "Appointment status",
    "appt_description": "Appointment description",
    "recurring_details": "Recurring details",
    "event_description": "Event description",
    "in_contact_timezone": "In contact's Timezone",
    "vacation_message": "Going on vacation? Taking some time off? Block off time on your calendar to prevent clients from booking appointments existing appointments will still remain on your calendar).",
    "contact": "Contact",
    "delete": "Delete",
    "cancel": "Cancel",
    "back": "Back",
    "pick_available_contacts": "Or pick from available contacts",
    "no_contacts_found": "No contacts found",
    "found": "found",
    "select_one": "Select one",
    "tz_tooltip": "This matters only if you're using Custom Values; such as appointment_start_time appointment_end_time appointment_timezone etc.. in your outbound communication with your clients or customers. And what it simply does is converts the aforesaid details into their local time.",
    "meeting_location_tooltip": "The meeting location will be set as configured in the calendar.",
    "appt_meeting_location_tooltip": "The user can set the meeting location specific to the appointment.",
    "gmeet_tooltip": "Please make sure the respective team member has a Google calendar set as their primary calendar.",
    "zoom_tooltip": "Please make sure the respective team member has Zoom integrated.",
    "enter_meeting_location": "Enter meeting location",
    "save_appointment": "Save appointment",
    "save_event": "Save event",
    "search_contacts": "Search by name, email, phone or company",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Custom timezone",
    "system_timezone": "System timezone",
    "contact_timezone": "Contact timezone",
    "account_timezone": "Account timezone",
    "an_error_occurred": "An error occurred"
  },
  "popup": {
    "calendar": "Calendar",
    "appointment_owner": "Appointment owner",
    "source": "Source",
    "booked_by": "Booked by",
    "view_activity_log": "View activity log",
    "status": "Status",
    "cancel_appointment": "Cancel appointment",
    "cancel_all": "Cancel all",
    "google_event": "Google event",
    "outlook_event": "Outlook event",
    "blocked_slot": "Blocked-off slot",
    "appointment": "Appointment",
    "confirmed": "Confirmed",
    "unconfirmed": "Unconfirmed",
    "cancelled": "Cancelled",
    "showed": "Showed",
    "no_show": "No show",
    "invalid": "Invalid",
    "more": "More",
    "less": "Less",
    "edit": "Edit",
    "reschedule_all": "Reschedule all",
    "guests": "Guest(s)",
    "guest_count": "Guest(s) count"
  },
  "create_calendar": {
    "calendar_name": "Calendar name",
    "calendar_logo": "Calendar logo",
    "select_team_member": "Select team members",
    "select_single_team_member": "Select team member",
    "eg_outbound_reach": "(eg) Outbound reach",
    "description": "Description",
    "amount": "Amount",
    "description_placeholder": "Write description",
    "meeting_duration": "Meeting duration",
    "meeting_location": "Meeting location",
    "seats_per_class": "Seats per class",
    "group": "Group",
    "custom_url": "Custom URL",
    "meeting_invite_title": "Meeting invite title",
    "event_color": "Event color",
    "availability_type": "Availability type",
    "new_calendar": "New calendar",
    "add_description": "Add description",
    "remove_description": "Remove description",
    "booking_availability": "Booking availability",
    "slug_tooltip": "Customize the booking widget URL.",
    "meeting_location_tooltip": "Meeting Links are shown in calendar Events as the 'Meeting location' and allow you to add things like zoom links for the event.",
    "advanced_settings": "Advanced settings",
    "show_more_schedule": "Show more",
    "show_more_helper_text": "To further customize your business hours, please head to the advanced settings.",
    "reschedule_preference": "Reschedule preference",
    "reschedule_preference_subtext": "If a {contactLabel} reschedules an appointment:",
    "reassign_through_round_robin": "Reassign through round robin",
    "keep_same_assinged_user": "Keep the same appointment owner",
    "new_appointment_preference": "New appointment preference",
    "new_appointment_preference_text": "Always book with the {contactLabel}'s assigned user.",
    "new_appointment_preference_subtext": "Book new appointments with the {contactLabel}'s assigned user instead of using round-robin scheduling.",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "service_calendar_name": "Service name",
    "service_logo": "Service logo",
    "service_select_team_member": "Select staff member",
    "service_duration": "Service duration",
    "appointment_invite_title": "Appointment invite title",
    "payment_placeholder": "Enter a description that will be displayed to the user, informing them about the payment",
    "deposit_amount": "Deposit amount",
    "collect_deposit_amount": "Accept partial payment",
    "percentage": "Percentage",
    "total_amount": "Total amount",
    "enter_meeting_location": "Enter meeting location",
    "accept_payments": "Accept payments",
    "aria": {
      "should_accept_payment": "Should accept payment"
    },
    "calendar_name_tooltip": "Calendar name to be displayed on the booking widget.",
    "booking_availability_tooltip": "Set the days and hours during which bookings can be made. These are your default weekly business hours shown to users when selecting a time slot.",
    "select_team_member_tooltip": "Select the team member(s) who would be taking this meeting.",
    "seats_per_class_tooltip": "Set the maximum number of participants allowed to book this class. Once all seats are filled, the time slot will no longer be available for booking.",
    "meeting_color": "Meeting color",
    "meeting_duration_tooltip": "This sets the length of your meeting, determining how long it will last."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Quick tip",
      "timezone_change_tip": "Time zones can be changed anytime under timezone preferences",
      "save": "Save changes",
      "close": "Close",
      "meeting_details": "Basic details",
      "availability": "Availability",
      "forms_and_payment": "Forms & payment",
      "notifications_and_additional_options": "Notifications & additional options",
      "connections": "Connections",
      "customizations": "Customizations",
      "create": "Create",
      "edit": "Edit",
      "equipments": "Rooms & equipment",
      "service_details": "Service details",
      "booking_rules": "Booking rules",
      "advanced_settings": "Advanced settings",
      "form_and_confirmation": "Form & confirmation",
      "payments": "Payments",
      "notifications_and_policies": "Notifications & policies",
      "widget_appearance": "Widget appearance",
      "saving_changes": "Just a moment — saving the latest changes...",
      "calendar_id": "Calendar ID",
      "saveCalendarSuccess": "Calendar saved successfully",
      "external_sync": "External sync",
      "booking_channels": "Booking channels",
      "meeting_location": "Meeting location",
      "staff_location": "Staff & location"
    },
    "meeting_details": {
      "meeting_location": "Meeting location",
      "meeting_location_label": "Meeting location",
      "enter_meeting_location": "Enter meeting location",
      "click_to_upload": "Click to upload",
      "square": "Square",
      "circle": "Circle",
      "remove_logo": "Remove logo",
      "meeting_invite_title_tooltip": "This is the title for the calendar meeting that shows in your Appointments list view, Calendar view and third party calendars.",
      "event_color_tooltip": "Choose a color for this booking event. Colors get synched to events in Google calendars.",
      "enter_a_name": "Please enter a name.",
      "enter_an_event_title": "Please enter an event title.",
      "high_priority": "High priority",
      "medium_priority": "Medium priority",
      "low_priority": "Low priority",
      "priority": "Priority",
      "custom": "Custom",
      "zoom_not_added": "The user has not connected their Zoom account yet.",
      "opt_avail": "Optimize for availability",
      "opt_equal": "Optimize for equal distribution",
      "team_members": "Select team members",
      "team_members_location": "Select staff & assign meeting location",
      "team_member": "Select team member",
      "team_member_location": "Select staff & assign meeting location",
      "meeting_location_required": "Meeting location is required.",
      "meeting_details": "Basic details",
      "meeting_details_description": "Basic information used to identify this calendar.",
      "or_drag_and_drop": "or drag and drop",
      "service_details": "Service details",
      "team_member_disabled_recurring_tooltip": "Recurring meetings allow only one team member. To add multiple team members, please disable recurring meetings.",
      "team_member_disabled_class_booking_tooltip": "Only one team member can be added to a class booking calendar.",
      "advanced_settings": "Advanced settings",
      "enable_contact_assigned_to_setting": "To enable this setting, the Form must be first in the widget order. Please rearrange the widget order from the Forms & Payment tab.",
      "reschedule_preference_setting_tooltip": "Choose who the appointment should be assigned to when a {contactLabel} reschedules from the booking widget.",
      "appointment_preference_tooltip": "Choose whether new appointments should always be booked with the {contactLabel}'s assigned user. If a {contactLabel} has an assigned user, that user will be given preference; otherwise, it will be a round-robin assignment. Tip: Turn off 'Allow staff selection' to prevent bookers from changing the staff member on the booking widget.",
      "add_location": "Add location",
      "multiple_locations_neo": "Offer multiple location options for the booker to choose from. Multiple locations are only supported by the Neo Widget.",
      "make_owner": "Make owner",
      "only_one_team_member": "Only one team member is allowed when multiple locations are added.",
      "ask_the_booker_error_message": "Ask the booker location already exists.",
      "enter_location": "Enter location value",
      "enter_display_label": "Enter display label",
      "add_display_label": "Add display label",
      "multiple_location_support_message": "Offer multiple location options for the booker to choose from. Multiple locations are only supported by the Neo Widget.",
      "only_one_team_member_personal_calendar": "Only one team member is allowed for personal booking. ",
      "ms_teams_not_added": "The user has not connected their Microsoft Teams account yet.",
      "enable_new_appt_preference": "Enable new appointment preference",
      "enable_new_appt_preference_desc": "Turning on \"<b>Always book with the {contactLabel}'s assigned user</b>\" will automatically set the <b>Form</b> as the first step in the widget order.",
      "location_exists_toast": "Meeting location already added",
      "not_supported_with_multiple_team_members": "Not supported with multiple team members",
      "not_supported_personal_calendar": "Not supported in personal calendar",
      "not_supported_class_booking": "Not supported in class booking calendar",
      "not_supported_collective_booking": "Not supported in collective calendar",
      "not_supported_service_booking": "Not supported in service calendar",
      "not_supported_round_robin": "Not supported in round robin calendar",
      "not_supported_event": "Not supported in event calendar",
      "calendar_logo_tooltip": "Choose a logo to be shown on the booking widget.",
      "calendar_name_tooltip": "Calendar name to be displayed on the booking widget.",
      "description_tooltip": "Describe what the calendar is about, to be displayed on the booking widget.",
      "group_tooltip": "You can assign this calendar to a group (if created). Users accessing the group link can browse and book from all calendars in that group.",
      "custom_url_tooltip": "Customize the booking widget URL.",
      "meeting_color_tooltip": "Choose a color for this booking event. Colors get  synced to events in Google Calendars.",
      "add_display_label_tooltip": "Hide the actual location and show a custom label until the meeting is booked (applies when multiple locations are added).",
      "meeting_location_tooltip": "Select a location, or choose Custom to add any address or meeting link.",
      "team_members_location_tooltip": "Select the staff member who will take this meeting and set their meeting location.",
      "meeting_distribution": "Meeting distribution",
      "meeting_distribution_tooltip": "Choose how meetings are assigned to staff.",
      "opt_avail_tooltip": "Assign meetings to the staff member who is available at the selected time, regardless of previous bookings. Maximizes open slot utilization and booking success rates.",
      "opt_equal_tooltip": "Distribute meetings evenly among all staff by tracking previous bookings. Prioritizes fairness over availability.",
      "priority_tooltip": "Set the preference level for assigning meetings when multiple staff are available. Higher priority staff will be considered first for bookings, followed by medium and low priority staff.",
      "contact_routing_preference": "Contact routing preference",
      "contact_routing_preference_tooltip": "Define how new and returning {contactsLabel} are assigned to staff — either by round robin or their original owner.",
      "team_members_location_owner_tooltip": "The main user who owns the meeting and provides the final meeting location.",
      "owner": "Owner",
      "upload_from_system": "Upload from system",
      "choose_from_media_storage": "Choose from media storage",
      "only_one_team_member_allowed": "Only one team member is allowed.",
      "at_least_two_team_members_required": "At least 2 team members are required.",
      "at_least_one_team_member_required": "At least one team member is required.",
      "widget_shape": "Widget shape:",
      "widget_bookings_path": "/widget/bookings/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profile-photo",
      "meeting_location_placeholder": "Meeting location",
      "team_member_meeting_location": "Staff & meeting location",
      "meeting_location_desc": "Assign staff to this calendar and set where meetings take place.",
      "event_calendar_meeting_location_desc": "Choose where the meeting will take place."
    },
    "meeting_location": {
      "ask_the_booker": "Ask the booker (booker enters the location)",
      "ask_the_booker_desc": "The booker is asked to enter a meeting location of their choice when booking",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Phone",
      "full_address": "Full address",
      "custom": "Custom",
      "meeting_location": "Meeting location"
    },
    "availability": {
      "my_availability": "My availability",
      "calendar_availability": "Calendar availability",
      "calendar_availability_desc": "Set when meetings can be booked on this calendar.",
      "set_availability": "Set your availability for the calendar here.",
      "standard": "Standard",
      "custom": "Custom",
      "to": "To",
      "copy_to_all": "Copy to all",
      "add_time": "Add time",
      "recurring_meeting": "Recurring meeting",
      "recurring_info": "Only one user per calendar for recurring booking.",
      "repeat": "Repeat",
      "times_to_repeat": "Times to repeat",
      "slots_unavailable": "If slots are unavailable?",
      "overlap_status": "Appointment status for overlapping slots ",
      "meeting_interval": "Meeting interval",
      "meeting_duration": "Meeting duration",
      "minimum_scheduling": "Minimum scheduling notice",
      "date_range": "Date range",
      "maximum_bookings_per_day": "Maximum bookings per day",
      "maximum_bookings_per_slot": "Maximum bookings per slot",
      "maximum_bookings_per_slot_per_user": "Maximum bookings per slot (per user)",
      "seats_per_class": "Seats per class",
      "pre_buffer_time": "Pre buffer time",
      "post_buffer_time": "Post buffer time",
      "pre_buffer_tooltip": "Pre-Buffer is additional time that can be added before an appointment, allowing for extra time to get ready.",
      "post_buffer_tooltip": "Post-Buffer is additional time that can be added after an appointment, allowing for extra time to wrap up.",
      "buffer_time": "Buffer time",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "skip_booking": "Skip booking unavailable slots",
      "continue_booking": "Continue booking",
      "book_next_available": "Book next available slot",
      "confirmed": "Confirmed",
      "unconfirmed": "Unconfirmed",
      "enter_valid_hours": "Please enter valid open hours",
      "enter_valid_avail": "Please enter valid custom availability",
      "availability_type_tooltip": "Choose Standard Availability for regular bookings offered weekly. Choose Custom for bookings only available on specific dates.",
      "meeting_interval_tooltip": "Controls how often booking slots are shown.\nFor a 30-minute meeting: \n• Choose 1 hour to show slots at the top of each hour. \n• Choose 30 minutes to show slots every 30 minutes.",
      "date_range_tooltip": "Events can be scheduled over the next n days.",
      "maximum_bookings_per_day_tooltip": "Maximum number of meetings permitted per day on this calendar.",
      "maximum_bookings_per_slot_tooltip": "Limit how many meetings a user can receive in the same time slot. If the limit is reached, the booking is assigned to the next user in the round-robin queue or the slot becomes unavailable.",
      "add_days": "Add days",
      "month_on_day": "Monthly on day",
      "month_on_last_day": "Monthly on last day",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "mins": "Minutes",
      "hours": "Hours",
      "days": "Days",
      "weeks": "Weeks",
      "months": "Months",
      "meeting_interval_error": "Meeting interval must be between 5 mins and 12 hours.",
      "meeting_duration_error": "Meeting duration must be between 1 min and 12 hours.",
      "buffer_time_error": "Buffer time must be less than 12 hours.",
      "appointment_interval": "Appointment interval",
      "appointment_duration": "Appointment duration",
      "maximum_appointments_per_day": "Maximum appointments per day",
      "subTitle": "Choose the date to set specific hours.",
      "heading_1": "Weekly available hours",
      "scheduling_availability_heading": "Booking availability",
      "scheduling_availability_tooltip": "Use an existing availability schedule or create a custom one for this calendar.",
      "tooltip_1": "Set your weekly availability schedule. These are your standard hours that will be applied consistently on a weekly basis.",
      "heading_2": "When are you available?",
      "unavailable_label": "Unavailable",
      "tooltip_2": "Adjust your schedule for specific dates. Override your regular weekly hours by marking availability or unavailability for selected dates.",
      "date_specific_level": "Add date specific hours",
      "specific_hours_button": "Date specific hours",
      "specific_hours_description": "Set custom availability for specific dates that differ from your weekly schedule.",
      "overlap_error": "Time slots cannot overlap",
      "apply": "Apply",
      "copy_times_to": "Copy times to",
      "no_date_specific_heading": "No date specific time added.",
      "no_date_specific_description": "You can add/remove specific date and time to your availability.",
      "recurring_disabled_conditions_tooltip": "Recurring meetings are disabled. To activate them, ensure that the calendar has only one team member and does not have date-specific hours or partial payment added.",
      "date_specific_hours_disabled_conditions_tooltip": "To include a date-specific hour, please ensure that recurring meetings are turned off.",
      "recurring_disable_event_calendar_conditions": "Recurring meetings are disabled. To activate them ensure that no date-specific hours or partial payment added.",
      "service_duration": "Service duration",
      "service_interval": "Service interval",
      "service_interval_tooltip": "The meeting interval sets how often booking slots appear on the calendar. For example, for a 30 minute event, a 1-hour interval means slots appear every hour.A 30-minute interval means slots appear every 30 minutes.",
      "service_duration_tooltip": "This sets the length of your appointment, determining how long it will last.",
      "minimum_scheduling_tooltip": "This sets the minimum time required to book an appointment via the calendar widget. For example, if set to 4 hours, appointments cannot be booked within 4 hours of their start time; bookings must be made at least 4 hours in advance.",
      "look_busy_title": "Look busy",
      "look_busy_helper_text": "Hide a percentage of your available appointment slots on the booking widget to appear busier and in high demand.",
      "look_busy_percentage_description": "Hide the number of available slots by x%.",
      "skip_specific_days": "Skip specific days in booking window",
      "select_days_to_exclude": "Select days to exclude from booking window.",
      "skip_days_info": "Selected days will be skipped from the booking window. Your booking window will extend to include the next available day.",
      "excluded_weekdays_error": "At least one weekday must remain available for booking.",
      "maximum_bookings_per_slot_tooltip_personal": "Maximum number of meetings allowed in a single time slot.",
      "enable_recurring_title": "Enable recurring meeting",
      "enable_recurring_desc": "Turning on <b>Recurring meetings</b> will automatically disable the following settings, as they cannot coexist:",
      "date_specific_hours": "All <b>Date-specific hours</b> will be removed.",
      "multiple_team_members": "<b>Multiple team members</b> will be removed—only one team member can remain in this calendar.",
      "partial_payments": "<b>Partial Payments</b> will be disabled, and the full amount will be collected.",
      "select_team_member_to_keep": "Select a team member to keep in this calendar:",
      "select_team_member": "Select team member",
      "partial_payments_disabled": "Since partial payments will be disabled, how would you like to collect the full amount for recurring appointments?",
      "enable_date_specific_hours": "Enable date specific hours",
      "enable_date_specific_hours_desc": "Turning on <b>Date-specific hours</b> will automatically disable the following setting, as they cannot coexist:",
      "recurring_meetings_disabled": "<b>Recurring meetings will be turned off</b>, {contactsLabel} will only be able to book single appointments based on the available dates you set.",
      "payment_preference": "Payment preference:",
      "team_members_in_this_calendar": "Team members in this calendar",
      "other_team_members": "Other team members (Not added to this calendar)",
      "select_team_member_tooltip": "Select the team member(s) who would be taking this meeting.",
      "meeting_duration_tooltip": "This sets the length of your meeting, determining how long it will last.",
      "date_specific_hours_tooltip": "Adjust your schedule for specific dates. Override your regular weekly hours by marking availability or unavailability for selected dates.",
      "recurring_meeting_tooltip": "Allow meetings to repeat multiple times over a time period.",
      "repeat_frequency_tooltip": "Select the frequency of this recurring event.",
      "time_to_repeat_tooltip": "Set the total number of recurrences.",
      "slots_unavailable_tooltip": "Choose what should happen if one or more time slots in a recurring booking are already booked.",
      "skip_booking_tooltip": "Only the available slots will be booked. Any unavailable dates in the recurring series will be skipped.",
      "force_book": "Force book",
      "force_booking_tooltip": "All slots will be booked, even if there is a conflict. Use with caution to avoid double-booking.",
      "book_next_available_tooltip": "If a selected slot is unavailable, books the next available slot on the same recurring schedule (e.g., next Monday if weekly).",
      "slot_interval_tooltip": "Set the gap between the start times of consecutive available slots. For example, if your meeting duration is 30 minutes and you set the interval to 60 minutes, a user can book at 9:00 AM, then 10:00 AM, and so on — even though each meeting lasts only 30 minutes.",
      "minimum_scheduling_notice_tooltip": "Require users to book meetings at least this much time in advance.",
      "date_range_preferences_tooltip": "Set how far into the future bookings can be made from today’s date.",
      "maximum_bookings_per_slot_preferences_tooltip": "Limit how many meetings can be scheduled for the same time slot.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Limit how many meetings can be scheduled for the same time slot (per user).",
      "pre_buffer_time_tooltip": "Time to block before each meeting, allowing for extra time to prepare.",
      "post_buffer_time_tooltip": "Time to block after each meeting, allowing for extra time to wrap up.",
      "seats_per_class_tooltip": "Set the maximum number of participants allowed to book this class. Once all seats are filled, the time slot will no longer be available for booking.",
      "maximum_bookings_per_slot_per_user_tooltip": "Limit how many meetings can be scheduled for the same time slot (per user).",
      "repeat_frequency": "Repeat frequency",
      "slot_interval": "Slot interval",
      "skip_booking_helper_text": "Only the available slots will be booked. Any unavailable dates in the recurring series will be skipped.",
      "force_book_helper_text": "All slots will be booked, even if there is a conflict. Use with caution to avoid double-booking.",
      "book_next_available_helper_text": "If a selected slot is unavailable, books the next available slot on the same recurring schedule (e.g., next Monday if weekly).",
      "bulk_edit": "Bulk edit",
      "select_users": "Select users",
      "select_all": "Select all",
      "times_to_repeat_tooltip": "Set the total number of recurrences.",
      "custom_recurrence": "Custom recurrence",
      "repeats_every": "Repeats every",
      "availability_schedule": "Availability schedule",
      "availability_schedule_desc": "Set when meetings can be booked based on staff availability.",
      "no_users_added": "No staff added!",
      "no_users_added_description": "Please add staff to check their availability",
      "add_users": "Add staff",
      "minimum_scheduling_notice_error": "Please enter ≤ 1440 minutes.",
      "please_select_date": "Please select a date to continue"
    },
    "forms_payment": {
      "forms": "Forms & guests",
      "forms_sub": "Configure preferences for the final page that appears after a successful booking.",
      "select_form": "Select form",
      "enable_same_user_assignment": "Assign contacts to their respective calendar team members each time an appointment is booked.",
      "sticky_contacts_label": "Sticky {contactsLabel}",
      "sticky_contacts": "Pre-populate fields",
      "confirmation_page": "Confirmation page",
      "default": "Default",
      "redirect_url": "Redirect URL",
      "use_custom_form_rules": "Use custom form rules",
      "default_message_tooltip": "Shows the configured confirmation message after the appointment is booked.",
      "redirect_url_tooltip": "Redirects the customer to the configured page after the appointment is booked.",
      "use_custom_form_rules_tooltip": "Uses the redirect or custom message defined in the custom form. If no rule applies, the calendar's confirmation message will be shown.",
      "thank_you": "Thank you message",
      "enter_url": "Enter URL",
      "enter_thank_you_message": "Enter thank you message.",
      "amount_tab_hidden_label": "Amount tab placeholder",
      "percentage_tab_hidden_label": "Percentage tab placeholder",
      "pixel_id": "Meta pixel ID (optional)",
      "auto_confirm": "Auto-confirm new calendar meetings",
      "configure_payment": "Configure payments options",
      "accept_payments": "Accept payments",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Add guests",
      "add_guest_tooltip": "Add guest will allow your attendee to add multiple attendees to the same appointment.",
      "add_guest_custom_form_tooltip": "Enabling this option will send a system-generated email to guests with a link to the custom form once their appointment is confirmed. To prevent duplicate emails, ensure a separate confirmation email is not already set up for guests. (Verify this in the Notifications tab > Confirmation Notification).",
      "add_guest_same_form_check": "Send same form to collect information via mail to all guests.",
      "payment_tooltip": "Payment would only be considered for the main attendee and not for the guests.",
      "default_form": "Default (First name, Last name, Email, Phone, Notes)",
      "select_form_tooltip": "If you would like to collect more information than the standard First name, Last name, Email, and Phone from those who book on this calendar, create a custom form in Sites > Forms > Builder then select the form via the dropdown below.",
      "confirmation_page_tooltip": "Once someone makes a booking, you can choose to show them a custom message on the same page (Default) or redirect them to a page of your choice (Redirect).",
      "add_guest_collect_email": "Name and email",
      "add_guest_count_only": "Count only",
      "custom_email_notification": "Send custom form to Guests.",
      "consent_label": "Consent checkbox",
      "consent_input_placeholder": "Add consent text",
      "same_user_assignment_tooltip": "To enable this setting, the Form must be first on the widget. Rearrange the widget to position the Form first to activate this setting.",
      "consent_tooltip": "Ask contacts to provide consent when booking a meeting.",
      "stripe_error": "Upto two decimals (example: 25.99)",
      "auto_confirm_service": "Auto-confirm new appointments",
      "service_form_message": "If a contact is booking multiple services, they will only see the default form in the service menu.",
      "deposit_amount_error": "Deposit amount must be less than total amount.",
      "deposit_percentage_error": "Deposit percentage must be less than 100%.",
      "partial_payment_tooltip": "Enable partial payments to collect deposit amount from customers during the appointment booking process.",
      "partial_payment_enable_error": "The total amount entered must be greater than 0 to enable partial payments.",
      "payment_disable_text_integration": "Integrate a payment provider under Payments > Integrations to start accepting payments",
      "payment_disable_text_recurring": "Accept payment option is unavailable for recurring meetings. Turn off recurring to enable payments.",
      "date_and_time_selector": "Date & time selector",
      "form_selector": "Form",
      "order_step": "Step",
      "widget_order_label": "Widget order",
      "widget_order_tool_tip": "Rearrange the 'Date & time selector' and 'Form' order on the calendar widget. Simply drag and reorder according to your preference.",
      "widget_re_order_tooltip": "Reordering is only available with the Neo widget style. Switch to Neo to enable reordering.",
      "widget_re_order_disabled_tooltip": "To rearrange the widget order, please disable 'New appointment preference (Always book with {contactLabel}'s assigned user)' from Meeting Details > Team Members > Advanced Setting section.",
      "payment_description_error": "Maximum character limit of 1000 reached.",
      "widget_multiple_location_disabled_tooltip": "The Classic Widget does not support multiple meeting locations. Please remove any additional locations to use the Classic Widget.",
      "recurring_payment_label": "Recurring appointments payment",
      "enable_payments_for_guests": "Enable payments for guests",
      "guest_payment_description": "Since you've enabled the \"Add Guests\" option, you can also choose to charge for each attendee at the time of booking.",
      "charge_per_attendee": "Charge per attendee",
      "charge_per_attendee_description": "Multiply the total amount by the number of attendees (including guests) when collecting payment during booking.",
      "click_confirm_description": "Click save to apply these changes.",
      "multiply_amount_guests": "Collect payment for all attendees",
      "multiply_amount_guests_description": "When enabled, the amount to be collected during booking will be multiplied by the total number of attendees, including guests.",
      "first_appointment_only": "Charge for the first appointment only",
      "all_appointments": "Charge for all appointments upfront",
      "no_payment_provider_connected": "No payment provider connected.",
      "no_default_payment_provider": "No payment provider connected",
      "provider_not_supported": "Default payment provider is not supported",
      "manage_payment_provider": "Manage payment providers",
      "supported_providers": "Supported providers",
      "paypal_razorpay_helper_text": "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers.",
      "rearrange_widget_order": "Rearrange widget order",
      "change_form_order": "Changing the Form to the second step in the widget order will disable the following setting:",
      "change_form_order_desc": "<b>New appointment preference (Always book with {contactLabel}'s assigned user)</b> will be turned off. This means appointments can be booked with any available team member, instead of being restricted to the {contactLabel}'s assigned user.",
      "enable_mandatory_guest": "Make adding at least one guest mandatory. Guest fields will be pre-opened and must be filled before booking.",
      "enable_mandatory_guest_count": "Take mandatory guest count on the booking widget.",
      "require_guest_for_booking": "Require guests for booking",
      "sticky_contacts_tooltip": "Auto-fill fields for known {contactsLabel}.",
      "auto_confirm_tooltip": "Automatically mark new meetings as confirmed without requiring manual approval. Disable this if you want to review and confirm each booking manually before it's scheduled.",
      "confirm_tooltip": "Once someone makes a booking, you can choose to show them a custom message on the same page (Default) or redirect them to a page of your choice (Redirect URL).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Enable payment collection during bookings.",
      "total_amount_tooltip": "Set the total fee for the meeting.",
      "deposit_amount_tooltip": "Amount to be collected while booking as a deposit.",
      "multiply_amount_guests_all_guests": "Collect payment for all attendees, including guests",
      "multiply_amount_guests_all_guests_tooltip": "When enabled, the amount to be collected during booking will be multiplied by the total number of attendees, including guests.",
      "payment_description": "Payment description",
      "payment_description_desc": "Displayed to the booker while entering payment details.",
      "payment_description_tooltip": "Optionally include any helpful details about the payment.",
      "test_mode_warning": "Test mode active – no real transactions will be processed.",
      "pixel_id_tooltip": "Send booking widget activity like views, clicks, and submissions to Meta using your Pixel ID.",
      "forms_description": "Set your preferences and settings for collecting customer information during bookings.",
      "payment_mode": "Payment mode",
      "payment_mode_tooltip": "Toggle between test mode and live mode for payments. In test mode, no real charges are made — use it to simulate the booking and payment process. Switch to live mode to accept actual payments from clients.",
      "enable_coupon": "Enable coupon codes",
      "enable_coupon_tooltip": "Allow customers to apply coupon codes during booking. To ensure they work, create valid coupons first under Payments > Coupon Codes.",
      "guests": "Guests"
    },
    "notifications": {
      "third_party_cal": "Third-party calendar settings",
      "third_party_cal_desc": "Set up your preferences for third-party calendars.",
      "additional_settings": "Additional settings",
      "additional_settings_desc": "Configure additional settings for your calendar.",
      "notifications": "Notifications",
      "notifications_sub": "Configure how you send booking notifications via email, SMS, WhatsApp, and in-app alerts.",
      "edit": "Edit",
      "created_on": "Created on",
      "updated_on": "Updated on",
      "delivered": "Delivered",
      "not_available": "N/A",
      "select_notification_type": "Select the type of notification.",
      "notification_person": "Who should receive this notification?",
      "contact": "{contactLabel}",
      "guest": "Guest",
      "assigned_user": "Assigned user",
      "emails": "Emails",
      "alert_email_address": "Alert email address",
      "ack_email": "Acknowledgement email",
      "send_google_invites": "Allow Google calendar to send invitation or update emails to attendees.",
      "assign_user_to_contact_desc": "When enabled, {contactLabel}’s assigned user will match the owner of the appointment with the most recent change — whether it’s been booked, rescheduled, or reassigned.",
      "send_google_outlook_invites": "Allow Google / Outlook / iCloud calendar to send invitation & update emails to attendees.",
      "assign_user_to_contact": "Assign {contactsLabel} to their respective calendar team members each time an appointment is booked.",
      "skip_assigning_user_to_contact": "Skip assigning {contactLabel} if the {contactLabel} has already an assigned user.",
      "skip_assigning_user_to_contact_desc": "When enabled, a {contactLabel}’s assigned user will remain the same, even if the appointment owner is different.",
      "assigned_staff": "Assigned staff",
      "additional_emails": "Additional emails",
      "assign_user_to_staff": "Always assign contact to the appointment owner.",
      "allow_cancellation": " Allow cancellation of meeting",
      "allow_reschedule": "Allow rescheduling of meeting",
      "allow_cancellation_tooltip": "When enabled, a cancellation link will be added to the additional notes section and included in the calendar invite. This link will expire as configured before the meeting start time, preventing the booker from canceling the meeting.",
      "allow_reschedule_tooltip": " When enabled, a rescheduling link will be added to the additional notes section and included in the calendar invite. This link will expire as configured before the meeting start time, preventing the booker from rescheduling the meeting.",
      "cancellation_link_expiry": "Cancellation link will expire",
      "reschedule_link_expiry": "Rescheduling link will expire",
      "before_meeting": "before the meeting",
      "cancellation_and_reschedule_policy": "Cancellation and reschedule policy:",
      "meeting_invite_notes": "Meeting invite notes",
      "meeting_invite_notes_tooltip": "Add notes that will appear in the calendar invite sent to customers. These notes will sync to third-party calendars in the meeting description."
    },
    "connections": {
      "connections_heading": "External calendar sync",
      "booking_channels_heading": "Booking channels",
      "booking_channels_description": "Set up how this calendar receives bookings from external platforms.",
      "connections_sub": "Sync meetings with external calendars and manage how events are handled.",
      "link_to_calendar": "Link to calendar",
      "sync_option": "Sync option",
      "execute_automation": "Execute automation",
      "fire_workflow": "Fire workflow triggers for events booked via two-way sync.",
      "reserve_with_google": "Reserve with Google [Deprecated]",
      "reserve_with_google_setup": "View setup instructions",
      "reserve_with_google_configure": "Configure",
      "change": "Change",
      "rwg_deprecation_notice": "Google has deprecated <b>Reserve with Google (Local Services Ads)</b>. New connections or changes to existing connections are no longer supported. To continue receiving bookings from Google, use <b>Google Organic Booking</b> instead.",
      "rwg_category": "Category",
      "rwg_service_type": "Service",
      "connect_lsa": "Connect with your local services Ads account.",
      "reserve_error": "Currently Reserve with Google is supported only for \"Home Services\", \"Real Estate\", \"Legal Services\" (Local Service providers) Company Niche in United States.",
      "one_way": "One way",
      "two_way": "Two way",
      "smart": "Smart",
      "confirm_remove": "Are you sure you want to remove Google calendar?",
      "read_only_access": "You do not have write access to this calendar. Please select a different calendar.",
      "reserve_with_google_desc": "This calendar service wil be listed in reserve with Google only on successful integration.",
      "check_integration": "Check your integration status",
      "setup_external": "Setup external calendar",
      "reserve_price_decimal_error": "Decimal price is not supported.",
      "reserve_price_max_error": "Price supported less than 1000.",
      "link_to_calendar_tooltip": "Select the external calendar to sync meetings with. Google calendars connected in Calendar settings → Connections are available to choose from.",
      "one_way_sync": "One way",
      "default_one_way": "Default sync (One-way sync)",
      "one_way_sync_desc": "Events from the linked calendar are synced as blocked slots, and no contacts are created for the guests.",
      "two_way_sync": "Two-way sync",
      "two_way_sync_desc": "Contacts are created for guests found in linked calendar events, and these events are turned into system appointments.",
      "smart_sync": "Smart sync",
      "smart_sync_desc": "Events from the linked calendar are synced as appointments for existing contacts. If no contact exists, they are synced as blocked slots without creating a new contact.",
      "sync_option_tooltip": "Choose how events from the external calendar are handled:\n• One-way: Blocks time on this calendar without creating {contactsLabel}\n• Two-way: Creates meetings and {contactsLabel} from external calendar events\n• Smart: Creates meetings only for existing {contactsLabel}, and blocks time for others.",
      "default_sync": "Default",
      "default_sync_desc": "Syncs events from your external calendar to this calendar.",
      "advanced_sync": "Advanced",
      "advanced_sync_desc": "Syncs events from your external calendar to this calendar and creates contacts and appointments in the system.",
      "assign_contact_to": "Assign contact to",
      "select_calendar": "Select calendar",
      "sync_preferences": "Sync preferences",
      "sync_preferences_desc": "How would you like to sync your linked calendar events?",
      "recommended": "Recommended",
      "execute_automation_desc": "Execute automation when a meeting is created in this calendar.",
      "save": "Save changes",
      "cancel": "Cancel",
      "reserve_with_google_title": "Reserve with Google",
      "current_connection": "Currently active connection :",
      "category": "Category",
      "service": "Service type",
      "price": "Estimated price",
      "currency": "Currency"
    },
    "booking_rules": {
      "booking_rules": "Booking rules",
      "booking_rules_description": "Control how and when meetings can be booked."
    },
    "payments": {
      "payments": "Payments",
      "payments_description": " Enable and manage payments, rules, and charge models."
    },
    "extras": {
      "extras": "Customizations",
      "extras_sub": "Set widget style and other preferences.",
      "calendar_widget_style": "Calendar widget style",
      "neo": "Neo",
      "classic": "Classic",
      "insert_custom_code": "Insert custom code",
      "show_seats_per_slot": "Show seats per slot",
      "allow_reschedule_meeting": "Allow reschedule meeting",
      "allow_cancelling_meeting": "Allow cancelling meeting",
      "additional_notes": "Additional notes",
      "cancellation_and_reschedule": "Cancellation and reschedule:",
      "allow_staff": "Allow staff selection during booking",
      "code_block_tooltip": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security,performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the calendar.",
      "calendar_image": "Calendar cover image",
      "remove_image": "Remove image",
      "calendar_image_info": "The uploaded image will be visible within the Group View for Neo template and won't appear on the individual calendar link.",
      "get_image_from_unsplash": "Enhance your visuals with",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configure additional preferences",
      "service_image": "Service cover image",
      "service_image_description": "Select an image which would be shown on the services menu for this service.",
      "allow_reschedule_appointment": "Allow reschedule appointment",
      "allow_cancelling_appointment": "Allow cancelling appointment",
      "custom_code_placeholder": "Please input custom code here",
      "calendar_widget_style_desc": "Choose between our classic or the sleek Neo widget.",
      "seats_per_slot": "Seats per slot",
      "show_staff_selection": "Staff selection",
      "seats_per_slot_desc": " Enable bookers to view the number of available seats for each time slot directly on the calendar widget.",
      "show_staff_selection_desc": "Enable bookers to choose a staff member directly from the calendar widget during appointment booking. Only works with Neo widget.",
      "widget_re_order_tooltip": "The classic widget style does not allow widget order changes. Ensure the Date Time Selector is first and the Form is second before selecting the Classic style.",
      "show_staff_selection_desc_service": "Enable bookers to choose a staff member directly from the calendar widget during appointment booking.",
      "switch_to_classic_widget": "Switch to classic widget",
      "switch_to_classic_widget_desc": "Changing to the <b>classic widget</b> will automatically disable the following settings, as they cannot coexist:",
      "form_first_disabled": "<b>The Form will be moved to the second step</b> in the widget order.",
      "appointment_preference_disabled": "<b>New appointment preference (Always book with {contactLabel}'s assigned user)</b> will be turned off. This means appointments can be booked with any available team member, instead of being restricted to the {contactLabel}'s assigned user.",
      "multiple_location_disabled": "<b>Multiple meeting locations</b> will be removed, and only the <b>first-added location</b> will be retained.",
      "insert_custom_code_tooltip": "Customize widget styling using your own CSS code.",
      "classic_tooltip_disabled": "Classic widget is not supported for class booking calendars.",
      "show_staff_selection_disabled_tooltip": "Staff selection is supported only for neo widget."
    },
    "roomsAndEquipments": {
      "title": "Select rooms and equipment",
      "description": "Select from a list of rooms and equipment what will be booked along with this calendar.",
      "rooms": "Select rooms",
      "equipments": "Select equipment"
    }
  },
  "activity_log": {
    "activity_log": "Activity log",
    "date": "Date",
    "filter_by": "Filter by",
    "calendar_update": "Calendar update",
    "start_time_update": "Start time update",
    "end_time_update": "End time update",
    "title_update": "Title update",
    "notes_update": "Notes update",
    "appointment_status_update": "Appointment status update",
    "meeting_location_update": "Meeting location update",
    "google_sync_update": "Google sync update",
    "outlook_sync_update": "Outlook sync update",
    "assigned_user_update": "Assigned user update",
    "appointment_status": "Appointment status",
    "assigned_user": "Assigned user",
    "uploaded_to": "Uploaded to",
    "cancelled": "Cancelled",
    "edited": "edited",
    "other_edits": "Other edits",
    "view_details": "View details",
    "all": "All"
  },
  "appointment_list": {
    "group_all": "ALL",
    "group_primary": "PRIMARY",
    "group_user": "USERS",
    "group_team": "GROUPS",
    "group_calendar": "CALENDARS",
    "all_appointments": "All appointments",
    "my_calendar": "My calendar",
    "status_all": "All",
    "status_confirmed": "Confirmed",
    "status_new": "New (Action required)",
    "status_show": "Showed",
    "status_no_show": "No show",
    "status_cancelled": "Cancelled",
    "status_invalid": "Invalid",
    "filter_date_added_desc": "Date added (Desc)",
    "filter_start_added_desc": "Start date (Desc)",
    "filter_start_added_asc": "Start date ascending from today",
    "button_new_appointment": "New appointment",
    "name": "Name",
    "title": "Title",
    "requested_time": "Requested time",
    "date_added": "Date added",
    "calendar": "Calendar",
    "appointment_owner": "Appointment owner",
    "notes": "Notes",
    "status": "Status",
    "action_view_detail": "View details",
    "action_view_consent": "View consent",
    "action_view_notes": "View notes",
    "action_edit": "Edit",
    "action_delete": "Delete",
    "action_reschedule": "Reschedule",
    "page_previous": "Previous",
    "page_next": "Next",
    "appointment_notes": "Appointment notes",
    "close": "Close",
    "confirm_delete_header": "Delete appointment",
    "confirm_delete_message": "Are you sure you want to delete this appointment? This action cannot be undone!",
    "confirm_delete_button": "Delete",
    "confirm_update_header": "Update appointment status",
    "confirm_update_confirmed_message": "Are you sure you want to mark this appointment as confirmed?",
    "confirm_update_invalid_message": "Are you sure you want to mark this appointment as invalid?",
    "confirm_update_showed_message": "Are you sure you want to mark this appointment as showed?",
    "confirm_update_noshow_message": "Are you sure you want to mark this appointment as no show?",
    "confirm_update_cancelled_message": "Are you sure you want to mark this appointment as cancelled?",
    "confirm_update_button": "Update",
    "empty_state_title": "No appointments found",
    "empty_state_description": "No appointments found.",
    "disable_menu_warning": "You don't have permission to view or edit the appointment details because the associated contact isn't assigned to you. Contact your admin for assistance.",
    "no_contact_warning": "You're unable to access contact information at the moment. This might be because the contact isn't assigned to you. Please reach out to your admin for assistance.",
    "consent_label": "Consent",
    "ip_address": "IP",
    "youre_viewing_in": "Currently viewing in",
    "appointment_delete_msg": "<b>Note:</b> The appointment deleted from here will not be deleted from Calendly.",
    "rescheduled": "Rescheduled"
  },
  "add_guest": {
    "guest_label": "Guest(s)",
    "search_placeholder": "Search from contacts",
    "add_new": "Add new",
    "save": "Save",
    "close": "Close",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "guest_label_count": "Guest(s) count",
    "guest_count_error": "Guest count should be between 1 and 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Service menu details",
    "select_groups_header": "Select services",
    "arrange_groups_header": "Arrange your services",
    "new_service_menu": "New service menu",
    "service_menu_sub_title": "Create a personalized service menu for your customers in just a few clicks",
    "quick_tip": "You can add groups to service menu",
    "service_menu_name": "Service menu name",
    "service_menu_description": "Description",
    "service_menu_slug": "Service URL",
    "select_groups_calendars": "Select groups and calendars",
    "select_groups_calendars_desc": "Add services to your service menu",
    "select_all": "Select all",
    "arrange_groups": "Arrange order of services",
    "arrange_groups_desc": "Determine the sequence of services on the service menu",
    "arrange_services_quicktip": "To rearrange calendars within group, go to Groups > Options > Rearrange Calendars.",
    "enable_add_guest_desc": "Allows customers to include additional guests when making a booking.",
    "enable_multiple_service_desc": "Allows customers to book multiple services in a single appointment.",
    "enable_staff_selection_desc": "Allows customers to select preferred staff members when making a booking.",
    "enable_add_guest": "Enable add guests",
    "enable_multiple_service": "Enable multiple service selection",
    "enable_staff_selection": "Enable staff selection",
    "additional_options": "Additional options",
    "code_block_tooltip": "Third-party scripts inside the HTML block can provide powerful functionality, but they also bring risks to privacy, security,performance and page behavior. Therefore, we recommend that you to review the contents of this script before saving it to the service menu.",
    "custom_code_placeholder": "Please input custom code here",
    "insert_custom_code": "Insert custom code",
    "no_service": "No service found",
    "no_service_desc": " No services found. Create services and add them to groups to create a service menu.",
    "learn_more": "Learn more",
    "no_service_selected": "No service selected",
    "create_service_calendars": "Create service calendars",
    "alert_description": " In order to create service menu, you need to create service calendars and add them to groups.",
    "dont_show_again": "Don't show this again",
    "service_name_required": "Service menu name is required",
    "slug_already_taken": "This slug is already taken",
    "slug_required": "Slug is required",
    "please_enter_name": "Please enter a name",
    "service_name_placeholder": "Main menu",
    "service_slug_placeholder": "main-menu",
    "form_label": "Form",
    "consent_label": "Consent checkbox",
    "consent_input_placeholder": "Add consent text",
    "consent_tooltip": "Toggle this option to allow obtaining consent from {contactsLabel} when they provide their phone number during the appointment booking process.",
    "back_message": "Back to list",
    "saving_changes": "Just a moment — saving the latest changes...",
    "payment_provider_warning": "Heads-up! Service Menus currently support payments only via Stripe and Authorize.net. Since your default provider differs, payment collection for selected calendars with payments enabled will be skipped.",
    "aria": {
      "consent_form_toggle": "Consent form toggle",
      "enable_add_guest_toggle": "Enable add guest toggle",
      "enable_multiple_services_toggle": "Enable multiple services toggle",
      "enable_staff_selection_toggle": "Enable staff selection toggle"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Customize calendar widget",
    "works_with_neo_widget": "Only works with Neo widget",
    "customise_widget_desc": "Customize widget appearance: primary color, background color, and button text.",
    "learn_more": "Learn more",
    "primary_settings": "Primary settings",
    "primary_settings_desc": "Configure the primary color, background color, and other widget preferences to tailor your calendar widget.",
    "primary_color": "Primary color",
    "primary_color_desc": "Define the color for buttons, dates, time slots, and actions.",
    "background_color": "Background color",
    "background_color_desc": "Set the background color that serves as the backdrop for both date-time selector and form.",
    "button_text": "Button text",
    "button_text_desc": "Customize the text displayed on the button when booking an appointment.",
    "calendar_title": "Calendar title",
    "calendar_title_desc": "The name of your calendar",
    "calendar_description": "Calendar description",
    "calendar_description_desc": "The entered description.",
    "calendar_details": "Calendar details",
    "calendar_details_desc": "Includes information such as duration, date & time, recurring details and timezone.",
    "reset_to_default": "Reset to default",
    "preview_widget": "Preview widget",
    "calendar_title_tooltip": "Set if the calendar name and group name (if applicable) should be visible on the booking widget.",
    "calendar_description_tooltip": "Set if the calendar description should be visible on the booking widget.",
    "calendar_details_tooltip": "Set if the key meetings details such as meeting duration, selected date & time, and recurrence info (if applicable) should be visible on the booking widget.",
    "insert_custom_code_tooltip": "Customize widget styling using your own CSS code.",
    "staff_selection_tooltip": "Enable bookers to choose a staff member directly from the calendar widget during appointment booking. Only works with Neo widget."
  },
  "eventNotification": {
    "customFields": "Custom fields",
    "customValues": "Custom values",
    "templateVariableIssueDefaultPartBefore": "There are issues with your ",
    "templateVariableIssueDefaultPartHighlight": "custom values",
    "templateVariableIssueDefaultPartAfter": "; please review and fix them before saving.",
    "templateVariableInvalidListOverflow": "… and {count} more",
    "templateVariableIssueSingle": "There's an issue with this custom value: {value}; please correct it before saving.",
    "templateVariableIssueEmpty": "One or more custom values are empty ({emptyPair}); please add a valid field inside the brackets.",
    "templateVariableIssueMarkup": "Some custom values include HTML or formatting, which isn't supported; please remove it before saving.",
    "guest": "Guest",
    "assignedUser": "Assigned user",
    "additionalEmails": "Additional emails",
    "list": {
      "booked": {
        "title": "Appointment booked (Status: Unconfirmed)",
        "modalTitle": "appointment booked (Status: Unconfirmed)",
        "note": "This notification is sent when a new appointment is created with Unconfirmed status.",
        "subTitle": "Notifies when an appointment is booked with an unconfirmed status."
      },
      "confirmation": {
        "title": "Appointment booked (Status: Confirmed)",
        "modalTitle": "appointment booked (Status: Confirmed)",
        "note": "This notification is sent when an appointment is created with or updated to the Confirmed status.",
        "subTitle": "Notifies when an appointment is successfully confirmed."
      },
      "cancellation": {
        "title": "Cancellation",
        "modalTitle": "cancellation",
        "note": "This notification is sent when an appointment is cancelled, marked as no-show, or marked as invalid.",
        "subTitle": "Alerts when an appointment is canceled."
      },
      "reschedule": {
        "title": "Reschedule",
        "modalTitle": "reschedule",
        "note": "This notification is sent when an appointment is rescheduled. It will only be triggered if the appointment is in Unconfirmed or Confirmed status.",
        "subTitle": "Notifies when an appointment is rescheduled."
      },
      "reminder": {
        "title": "Reminder",
        "modalTitle": "reminder",
        "note": "This notification is sent as a reminder before the appointment. It will only be triggered if the appointment is in Unconfirmed or Confirmed status.",
        "subTitle": "Sends a reminder before the appointment."
      },
      "followup": {
        "title": "Follow-Up",
        "modalTitle": "follow-up",
        "note": "This notification is sent after the appointment as a follow-up. It will only be triggered if the appointment is in Unconfirmed, Confirmed, or Showed status.",
        "subTitle": "Sends a follow-up message after the appointment is completed."
      }
    },
    "saveToastMsg": "Settings saved!",
    "saveToastMsgDesc": "Your changes have been successfully saved.",
    "enableSuccess": "Notifications enabled!",
    "disableSuccess": "Notifications disabled!",
    "tooltip": "This notification has been disabled. Please enable it to make any changes.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "statusLabel": "Status labels",
    "email": {
      "channelName": "Email",
      "noneTemplate": "None",
      "notificationLabel": "Who should receive this notification?",
      "sendButtonLabel": "Send test email",
      "testEmailLabel": "Test email",
      "testEmailPlaceholder": "Enter the recipient's email address for testing",
      "body": "Email body",
      "bodyPlaceholder": "Type your message here",
      "subject": "Subject",
      "subjectPlaceholder": "Enter the subject of the email",
      "templateLabel": "Email template",
      "templatePlaceholder": "Select an email template or start from scratch",
      "fromNamePlaceholder": "Enter name",
      "fromNameLabel": "From name",
      "fromAddressLabel": "From address",
      "alertEmailAddress": "Enter email IDs (separated by commas)",
      "addMore": "Add more",
      "afterAppointmentEnds": "after the appointment ends",
      "beforeAppointmentStarts": "before the appointment starts",
      "durationLabel": "When would you like to trigger the notification?",
      "disableEmailNotification": "Disable email notifications",
      "enableEmailNotification": "Enable email notifications",
      "enableSuccess": "Email notification enabled!",
      "enableSuccessDesc": "You will now start receiving this notification",
      "disableSuccess": "Email notification disabled!",
      "disableSuccessDesc": "You will no longer receive this notification",
      "reset_to_default": "Reset to default",
      "testEmailSuccessTitle": "Test email sent!",
      "testEmailSuccessDesc": "Test email has been successfully sent to {email}",
      "testEmailErrorTitle": "Failed to send test email",
      "testEmailErrorDesc": "There was an error sending the test email. Please try again.",
      "create_new_email_template": "Create new email template",
      "templateVariableFieldSubject": "Subject line",
      "templateVariableFieldFromName": "From name",
      "templateVariableFieldFromAddress": "From address",
      "templateVariableFieldEmailBody": "Email body"
    },
    "inApp": {
      "channelName": "In-app",
      "title": "Notification settings",
      "enableInAppNotification": "Enable in-app notification",
      "disableInAppNotification": "Disable in-app notification",
      "selectedUser": {
        "label": "Send to",
        "helperText": "This internal notification is sent via the web and mobile apps.",
        "placeholder": "Select user(s)"
      },
      "enableSuccess": "In-app notifications enabled!",
      "enableSuccessDesc": "You will now start receiving this notification.",
      "disableSuccess": "In-app notifications disabled!",
      "disableSuccessDesc": "You will no longer receive this notification."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "None",
      "notificationLabel": "Who should receive this notification?",
      "sendButtonLabel": "Send test SMS",
      "testSMSLabel": "Test SMS (enter phone number with country code)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS message",
      "bodyPlaceholder": "Type your SMS message here",
      "durationLabel": "When would you like to trigger the notification?",
      "disableSMSNotification": "Disable SMS notifications",
      "enableSMSNotification": "Enable SMS notifications",
      "enableSuccess": "SMS notification enabled!",
      "enableSuccessDesc": "You will now start receiving this notification.",
      "disableSuccess": "SMS notification disabled!",
      "disableSuccessDesc": "You will no longer receive this notification.",
      "alertPhoneNumbers": "Enter phone numbers (with country codes, separated by commas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Add more",
      "afterAppointmentEnds": "after the appointment ends",
      "beforeAppointmentStarts": "before the appointment starts",
      "templateLabel": "SMS template",
      "templatePlaceholder": "Select SMS template...",
      "reset_to_default": "Reset to default",
      "testSmsSuccessTitle": "Test SMS sent!",
      "testSmsSuccessDesc": "Test SMS has been successfully sent to {phone}.",
      "testSmsErrorTitle": "Failed to send test SMS",
      "testSmsErrorDesc": "There was an error sending the test SMS. Please try again.",
      "templateVariableFieldSmsBody": "Message body"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Who should receive this notification?",
      "sendButtonLabel": "Send test WhatsApp notification",
      "testWhatsAppLabel": "Test WhatsApp notification (enter phone number with country code)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "When would you like to trigger the notification?",
      "alertPhoneNumbers": "Enter phone numbers (with country codes, separated by commas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Add more",
      "afterAppointmentEnds": "after the appointment ends",
      "beforeAppointmentStarts": "before the appointment starts",
      "templateLabel": "WhatsApp template",
      "templatePlaceholder": "Select WhatsApp template...",
      "noPreview": "No template selected",
      "templateRequired": "Template required",
      "testWhatsAppSuccessTitle": "Test WhatsApp notification sent!",
      "testWhatsAppSuccessDesc": "Test WhatsApp notification has been successfully sent to {phone}.",
      "testWhatsAppErrorTitle": "Failed to send test WhatsApp notification.",
      "testWhatsAppErrorDesc": "There was an error sending the test WhatsApp notification. Please try again.",
      "setupTitle": "Reach out to your customer on their favorite messaging app.",
      "setupDescription": "Stay closer to your customers by providing instant support, sending timely updates, and creating engaging interactions.",
      "connectWhatsApp": "Connect WhatsApp",
      "checkingStatus": "Checking WhatsApp account status...",
      "checkingTemplateStatus": "Checking WhatsApp template status...",
      "statusCheckError": "Failed to check WhatsApp account status.",
      "templateStatusCheckError": "Failed to check WhatsApp template status.",
      "setupTemplateTitle": "Complete your WhatsApp template setup.",
      "setupTemplateDescription": "You need to set up WhatsApp templates before you can send notifications. Click below to complete the setup process.",
      "loadTemplatesError": "Failed to load WhatsApp templates.",
      "templatesRefreshed": "Templates refreshed successfully",
      "templatesRefreshError": "Failed to refresh templates.",
      "templatesResolveError": "Error resolving WhatsApp default templates.",
      "locationNotFound": "Location ID not found.",
      "settingsRedirectError": "Unable to redirect to WhatsApp settings.",
      "updateNotificationError": "Failed to update WhatsApp notification.",
      "notificationsEnabled": "WhatsApp notifications enabled!",
      "notificationsDisabled": "WhatsApp notifications disabled!",
      "updateError": "Error updating notifications.",
      "createNewTemplate": "Create new WhatsApp template",
      "phoneValidation": {
        "countryCodeRequired": "Phone number must start with a country code (e.g., +1, +91, +44)",
        "digitsOnly": "Phone number must contain only digits after the country code.",
        "tooShort": "Phone number is too short.",
        "tooLong": "Phone number is too long.",
        "invalid": "Invalid phone number."
      },
      "errors": {
        "templateNotFound": "Template ID not found in loaded options, clearing.",
        "templateNoLongerValid": "Saved template no longer valid, clearing.",
        "invalidTemplateSelection": "Attempted to select invalid WhatsApp template.",
        "fetchingTemplates": "Error in fetching WhatsApp templates.",
        "mountingCreator": "Error mounting WhatsApp Template Creator.",
        "fetchingAfterCreation": "Error in fetching WhatsApp templates after creation.",
        "updateStatus": "Error in update WhatsApp status."
      },
      "receiverLabels": {
        "assignedUser": "Assigned user",
        "phoneNumbers": "Additional phone numbers"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Create new SMS template",
    "create_new_template_desc": "Create a reusable SMS template for your notifications.",
    "template_name": "Template name",
    "template_name_placeholder": "Enter template name",
    "message": "Message",
    "message_placeholder": "Type your SMS message here.",
    "create_template": "Create template",
    "name_required": "Template name is required",
    "text_required": "Message text is required",
    "fetch_new_templates": "Refresh templates",
    "characters": "characters",
    "words": "words",
    "segments": "segs"
  },
  "whatsappTemplate": {
    "create_new_template": "Create new WhatsApp template",
    "create_new_template_desc": "Create a reusable WhatsApp template for your notifications.",
    "template_name": "Template name",
    "template_name_placeholder": "Enter template name",
    "message": "Message",
    "message_placeholder": "Type your WhatsApp message here.",
    "create_template": "Create template",
    "name_required": "Template name is required",
    "text_required": "Message text is required",
    "fetch_new_templates": "Refresh templates"
  },
  "archivedServices": {
    "servicesBanner": "A new, upgraded version of services is here—more powerful, flexible, and intuitive. Your Service calendars have already been migrated. Explore them now in the Services tab.",
    "archivedServiceCalendars": "Service calendars (v1)",
    "check_new_services": "Check new services"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Edit calendar",
      "share_calendar": "Share calendar",
      "troubleshoot_calendar": "Troubleshoot calendar",
      "more_options": "More options",
      "edit_calendar_desc": "Manage all calendar settings—set availability, configure notifications, adjust appointment limits, and more.",
      "share_calendar_desc": "Copy and share your scheduling link so bookers can easily schedule with you.",
      "troubleshoot_calendar_desc": "Find out why a slot isn't showing and view possible reasons in the troubleshooting view.",
      "more_options_desc": "Access additional settings and actions to manage your calendar.",
      "read_permissions": {
        "share_description": "Grant access to others by sharing the calendar link or adjusting permissions.",
        "troubleshoot_description": "Identify and resolve issues like sync errors or missing events for smooth functionality."
      },
      "next": "Next",
      "start_over": "Start over",
      "all_set": "All set!",
      "previous": "Previous"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Select your editing experience",
    "select_editing_experience_desc": "Choose to Build using our Visual Drag-and-Drop Design Editor or Powerful Code Editor.",
    "design_editor": "Design editor",
    "design_editor_desc": "Visual, drag & drop editing.",
    "code_editor": "Code editor",
    "code_editor_desc": "Feature-rich HTML editing.",
    "text_editor": "Plain text editor",
    "text_editor_desc": "Basic, clean, no-frills text editing.",
    "email_text_block": "Email can also be created using Text Block. ",
    "select": "Select",
    "new_template": "New template",
    "email_block": "Email can also be created using text block.",
    "fetch_new_templates": "Fetch new templates"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Use a clear meeting name and description so bookers know exactly what they're scheduling.",
      "groups_share_link": "Groups let you share one scheduling link for multiple calendars, allowing customers to choose and book from available options."
    },
    "staff_location": {
      "custom_location": "Choose Custom as the meeting location to enter any address or link of your choice.",
      "ask_booker_location": "When Ask the booker is selected, the booker is asked to enter the meeting location during booking",
      "round_robin_priority": "Priority settings affect how meetings are distributed when multiple staff are available.",
      "connect_video_integrations": "Connect video conferencing integrations from calendar settings → Connections before selecting them as the meeting location."
    },
    "availability": {
      "staff_availability_required": "Meetings can only be booked when at least one selected staff member is available.",
      "use_precreated_schedule": "You can use a pre-created availability schedule from Calendar settings → Availability or create a custom schedule just for this calendar.",
      "timezone_in_schedule": "The timezone for meetings is set within the selected availability schedule.",
      "event_24_hours": "To make a calendar available 24 hours, set the time range from 12 AM to 12 AM."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Booking rules apply to all meetings on this calendar, regardless of staff availability.",
      "minimum_scheduling_notice": "Increase the minimum scheduling notice to prevent last-minute bookings.",
      "maximum_bookings_per_slot": "Use maximum bookings per slot to control how many meetings can happen at the same time."
    },
    "forms": {
      "custom_contact_fields": "You can include custom contact fields in both form messages and form URLs.",
      "create_custom_form": "To collect more information, create a custom form from Sites → Forms → Builder and use it with this calendar."
    },
    "payments": {
      "collected_during_booking": "Payments are collected during booking and must be completed before the meeting is confirmed.",
      "payment_description": "Use the payment description to clearly explain what the charge is for."
    },
    "notifications": {
      "review_policies": "Review cancellation and rescheduling policies to avoid last minute changes.",
      "use_workflows": "For advanced automation, use Workflows with Appointment Booked trigger."
    },
    "customizations": {
      "preview_widget": "Preview the widget to ensure it matches your brand and booking flow.",
      "update_widget_language": "Language settings for the widget can be changed from Settings → Calendars → Preferences."
    },
    "connections": {
      "google_organic_booking": "Setting up Google Organic Booking allows this calendar to receive bookings directly from Google Search.",
      "external_sync_event": "Only the calendar selected under External sync is used to fetch and push events for this calendar."
    },
    "equipments": {
      "room_definition": "A 'room' can represent any location where services are provided. This could be physical rooms and/or dedicated stations. Eg: Pedicure Station.",
      "equipment_definition": "Think of 'equipment' as any tool or device that businesses use to fulfill appointments. This can include machines, devices, or even chairs."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Sticky contacts",
    "consent_form": "Consent form",
    "enable_guests": "Enable guests",
    "auto_confirm": "Auto confirm",
    "should_accept_payment": "Should accept payment",
    "collect_deposit": "Collect deposit",
    "enable_charge_guests": "Enable charge guests",
    "enable_coupon": "Enable coupon",
    "payment_live": "Payment live",
    "add_availability_hour": "Add availability hour",
    "remove_availability_hour": "Remove availability hour",
    "copy_availability_hour": "Copy availability hour",
    "close_modal": "Close modal",
    "add_custom_slot": "Add custom slot",
    "remove_custom_slot": "Remove custom slot",
    "edit_custom_slot": "Edit custom slot",
    "update_frequency": "Update frequency",
    "show_calendar_title": "Show calendar title",
    "show_calendar_description": "Show calendar description.",
    "show_calendar_details": "Show calendar details",
    "allow_reschedule": "Allow reschedule",
    "allow_cancellation": "Allow cancellation",
    "category_actions": "Category actions",
    "show_seats_per_slot": "Show seats per slots",
    "add_more": "Add more",
    "same_user_assignment_toggle": "Same user assignment toggle"
  },
  "placeholders": {
    "pixel_id": "Pixel ID",
    "select_one": "Select one",
    "meeting_location": "Meeting location",
    "schedule_meeting": "Schedule meeting",
    "notes": "Notes",
    "select_users": "Select users",
    "please_select": "Please select"
  },
  "alt_text": {
    "payment_provider": "Payment provider",
    "no_calendars": "No calendars",
    "date_specific_hours": "date-specific-hours",
    "custom_widget_image": "Custom widget image",
    "service_calendar": "Service calendar",
    "event_calendar": "Event calendar",
    "round_robin_booking": "Round robin booking",
    "class_booking": "Class booking",
    "collective_booking": "Collective booking",
    "calendar_cover_image": "Calendar cover image",
    "email_notification_switch": "Email notification switch",
    "email_template_icon": "Email template icon",
    "in_app_notification_switch": "In app notification switch",
    "sms_notification_switch": "SMS notification switch",
    "whatsapp_notification_switch": "WhatsApp notification switch",
    "no_service_found": "No service found",
    "no_group_found": "No group found",
    "sync_icon": "Sync icon",
    "sync_type": "Sync type",
    "test1": "test1",
    "test2": "test2"
  },
  "tooltips": {
    "text_color": "Text color",
    "background_color": "Background color",
    "strikethrough": "Strikethrough",
    "superscript": "Superscript",
    "subscript": "Subscript",
    "inline_code_block": "Inline code block",
    "code_block": "Code block",
    "block_quote": "Block quote",
    "more": "More",
    "upload": "Upload",
    "image_upload_tooltip": "PNG, JPEG, JPG or GIF (max. dimensions 180x180px | max. size 2.5mb).",
    "custom_values": "Custom values",
    "text_wrap": "Text wrap",
    "trigger_links": "Trigger links",
    "text_align": "Text align"
  },
  "labels": {
    "reset_style": "Reset style",
    "reset_document_style": "Reset document style",
    "source_code": "Source code",
    "success": "Success",
    "edit": "Edit",
    "submit": "Save",
    "cancel": "Cancel",
    "payment": "Payment",
    "here_is_the_link": "Here's the link:",
    "here_is_the_embed_code": "Here's the embed code:",
    "service_calendar": "Service calendar",
    "collective_booking": "Collective booking",
    "class_booking": "Class booking",
    "round_robin_booking": "Round robin booking",
    "event_calendar": "Event calendar",
    "personal_booking": "Personal booking",
    "service_booking": "Service booking",
    "calendar_id": "Calendar ID"
  },
  "validation_messages": {
    "calendar_group_name_required": "The calendar group name is required.",
    "calendar_group_description_required": "The calendar group description is required.",
    "slug_required": "Slug is required.",
    "slug_not_valid": "This slug is not valid.",
    "slug_already_taken": "This slug is already taken.",
    "error_validating_slug": "Error validating slug.",
    "please_enter_name": "Please enter a name.",
    "room_name_required": "Room name is required",
    "equipment_name_required": "Equipment name is required.",
    "subject_required": "The subject is required.",
    "this_is_required": "This is required.",
    "calendar_group_slug_required": "The calendar group slug is required.",
    "capacity_mandatory": "Capacity is mandatory.",
    "capacity_cannot_be_zero": "Capacity cannot be zero.",
    "capacity_should_be_a_number": "Capacity should be be a number.",
    "capacity_cannot_be_negative": "Capacity cannot be negative.",
    "capacity_should_be_a_whole_number": "Capacity should be a whole number.",
    "quantity_mandatory": "Quantity is mandatory",
    "quantity_cannot_be_zero": "Quantity cannot be zero.",
    "quantity_should_be_a_number": "Quantity should be be a number.",
    "quantity_cannot_be_negative": "Quantity cannot be negative.",
    "quantity_should_be_a_whole_number": "Quantity should be a whole number.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Quantity cannot be less than out of service equipments.",
    "out_of_service_value_should_be_a_number": "Out of service value should be be a number.",
    "out_of_service_cannot_be_negative": "Out of service cannot be negative",
    "out_of_service_equipments_qty": "Out of service equipments cannot be more than actual equipment Quantity.",
    "out_of_service_whole_number": "Out of service should be a whole number.",
    "slot_duration_required": "Slot duration is required.",
    "slot_duration_integer": "Slot duration should be an integer.",
    "meeting_duration_validation": "Meeting duration must be between 1 min and 12 hours",
    "seats_class_required": "Seats per class is required.",
    "seats_class_integer": "Seats per class should be an integer.",
    "seats_class_validation": "This cannot be greater than 9999 or less than 0.",
    "meeting_location_required": "Meeting location is required.",
    "meeting_location_empty": "Please enter a value for all location types.",
    "meeting_location_duplicate": "Duplicate value for same location type is not allowed.",
    "meeting_location_booker_multiple": "Ask the Booker is not allowed for multiple team members."
  },
  "custom_values": {
    "assigned_user": "Assigned user",
    "full_name": "Full name",
    "first_name": "First name",
    "last_name": "Last name",
    "email": "Email",
    "phone": "Phone",
    "twilio_phone": "Twilio phone",
    "account": "Account",
    "name": "Name",
    "full_address": "Full address",
    "city": "City",
    "state": "State",
    "country": "Country",
    "postal_code": "Postal code",
    "contact": "Contact",
    "address1": "Address 1",
    "timezone": "Timezone",
    "user": "User",
    "appointment": "Appointment",
    "start_date_time": "Start date time",
    "start_date": "Start date",
    "start_time": "Start time",
    "end_date_time": "End date time",
    "end_date": "End date",
    "end_time": "End time",
    "meeting_location": "Meeting location"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Phone",
    "full_address": "Full address",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Custom"
  },
  "duration_units": {
    "minutes": "Minutes",
    "hours": "Hours"
  },
  "widget_styles": {
    "classic": "Classic",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Service menu",
    "rooms": "Rooms",
    "equipments": "Equipments"
  },
  "lsa": {
    "categories": {
      "accountant": "Accounting",
      "acupuncturist": "Acupuncture",
      "air_duct_cleaner": "Air Duct Cleaning",
      "alcohol_treatment": "Alcoholism Treatment Services",
      "animal_shelter": "Animal Rescue Services",
      "appliance_repair": "Appliance Repair",
      "architect": "Architecture",
      "assisted_living": "Assisted Living Services",
      "babysitter": "Babysitting",
      "bankruptcy_lawyer": "Bankruptcy Law",
      "beauty_school": "Beauty School",
      "business_lawyer": "Business Law",
      "car_repair": "Auto Services",
      "carpenter": "Carpentry",
      "carpet_cleaning": "Carpet Cleaning",
      "child_care": "Child Care Services",
      "chiropractor": "Chiropractic Services",
      "cleaning_service": "House Cleaning",
      "contract_lawyer": "Contract Law",
      "countertop_pro": "Countertop Services",
      "criminal_lawyer": "Criminal Law",
      "dance_instructor": "Dance Instruction",
      "disability_lawyer": "Disability Law",
      "driving_instructor": "Driving Instruction",
      "dui_lawyer": "DUI Law",
      "electrician": "Electrical",
      "energy_efficiency_pro": "Energy Efficiency Services",
      "estate_lawyer": "Estate Law",
      "event_planner": "Event Planning",
      "family_lawyer": "Family Law",
      "fencing_pro": "Fencing",
      "financial_planner": "Financial Planning",
      "first_aid_trainer": "First Aid Training",
      "flooring_pro": "Flooring",
      "foundation_pro": "Foundations",
      "funeral_home": "Funeral Services",
      "garage_door_pro": "Garage Door",
      "general_contractor": "Home Improvement",
      "handyman": "Handyman",
      "home_inspector": "Home Inspection",
      "home_security": "Home Security Services",
      "home_theater": "Home Theater Services",
      "hvac": "HVAC",
      "immigration_lawyer": "Immigration Law",
      "interior_designer": "Interior Design",
      "ip_lawyer": "Intellectual Property Law",
      "junk_removal": "Junk Removal",
      "labor_lawyer": "Labor Law",
      "landscaper": "Landscaping",
      "language_instructor": "Language Instruction",
      "lawn_care": "Lawn Care",
      "litigation_lawyer": "Litigation Law",
      "locksmith": "Locksmith",
      "malpractice_lawyer": "Malpractice Law",
      "massage_center": "Massage Services",
      "massage_school": "Massage School",
      "mover": "Moving",
      "nursing_home": "Nursing Home Service",
      "painter": "Painting",
      "personal_injury_lawyer": "Personal Injury Law",
      "personal_trainer": "Personal Training",
      "pest_control": "Pest Control",
      "pet_adoption": "Pet Adoption Services",
      "pet_boarding": "Pet Boarding",
      "pet_grooming": "Pet Grooming",
      "pet_trainer": "Pet Training",
      "photographer": "Photography",
      "plumber": "Plumbing",
      "pool_cleaner": "Pool Cleaning",
      "pool_contractor": "Pool Contracting",
      "preschool": "Preschooling",
      "psychologist": "Psychology Services",
      "real_estate_agent": "Real Estate",
      "real_estate_lawyer": "Real Estate Law",
      "rehab": "Rehabilitation Services",
      "roofer": "Roofing",
      "sewage_pro": "Sewage System Services",
      "siding_pro": "Siding",
      "smart_home": "Smart Home Services",
      "snow_removal": "Snow Removal Services",
      "spa": "Spa Services",
      "tax_lawyer": "Tax Law",
      "tax_specialist": "Tax Services",
      "therapist": "Therapy",
      "towing_pro": "Roadside Assistance",
      "traffic_lawyer": "Traffic Law",
      "tree_service": "Tree Services",
      "tutor": "Tutoring",
      "upholstery_cleaner": "Upholstery Cleaning",
      "veterinarian": "Veterinary Services",
      "videographer": "Video Services",
      "water_damage": "Water Damage Services",
      "weight_loss_service": "Weight Loss Services",
      "window_cleaner": "Window Cleaning",
      "window_repair": "Window Services",
      "windshield_repair_pro": "Auto Glass",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Other",
      "bankruptcy_tax_litigation": "Bankruptcy Tax Litigation",
      "bookkeeping": "Bookkeeping",
      "business_consulting": "Business Consulting",
      "debt_collection_relief": "Debt Collection Relief",
      "irs_representation_resolution": "IRS Representation & Resolution",
      "payroll": "Payroll",
      "tax_planning_business": "Tax Planning Business",
      "tax_planning_individual": "Tax Planning Individual",
      "tax_return_business": "Tax Return Business",
      "tax_return_individual": "Tax Return Individual",
      "trusts_estates_accounting": "Trusts Estates Accounting",
      "acupressure": "Acupressure",
      "acupuncture": "Acupuncture",
      "acupuncturist_other": "Other",
      "cupping": "Cupping",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Heat Therapy",
      "herbal_therapy": "Herbal Therapy",
      "infrared_therapy": "Infrared Therapy",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Air Duct Cleaning",
      "air_duct_filter_replacement": "Filter Replacement",
      "air_duct_other": "Other",
      "dryer_vent_cleaning": "Dryer Vent Cleaning",
      "furnace_cleaning": "Furnace Cleaning",
      "indoor_air_quality_testing": "Indoor Air Quality Testing",
      "alcohol_treatment_other": "Other",
      "animal_shelter_cat_adoption": "Cat Adoption",
      "animal_shelter_dog_adoption": "Dog Adoption",
      "animal_shelter_other": "Other",
      "animal_shelter_other_animal_adoption": "Other Animal Adoption",
      "animal_shelter_other_veterinary_services": "Other Veterinary Services",
      "animal_shelter_spay_neuter": "Spay Or Neuter",
      "animal_shelter_vaccinations": "Vaccinations",
      "lost_stray_found_animals": "Lost, Stray, Or Found Animals",
      "pet_license": "Pet License",
      "pet_surrender": "Pet Surrender",
      "appliance_other": "Other",
      "repair_dishwasher": "Repair Dishwasher",
      "repair_dryer": "Repair Dryer",
      "repair_freezer": "Repair Freezer",
      "repair_microwave": "Repair Microwave",
      "repair_oven": "Repair Oven",
      "repair_refrigerator": "Repair Refrigerator",
      "repair_refrigerator_freezer": "Repair Refrigerator / Freezer",
      "repair_stove_cooktop": "Repair Stove / Cooktop",
      "repair_stove_cooktop_oven": "Repair Stove / Cooktop / Oven",
      "repair_washer": "Repair Washer",
      "repair_washer_dryer": "Repair Washer / Dryer",
      "3d_architectural_rendering": "3D Architectural Rendering",
      "adaptive_reuse_historical_renovation": "Adaptive Reuse & Historical Renovation",
      "architect_other": "Other",
      "architectural_designing": "Architectural Designing",
      "architectural_engineering": "Architectural Engineering",
      "building_code_analysis_permit_coordination": "Code Analysis And Permits",
      "consulting": "Consulting",
      "home_building_improvement": "Home Building & Improvement",
      "interior_design_architect": "Interior Design",
      "planning_zoning_approval_assistance": "Planning & Zoning Approval",
      "project_managing_architect": "Project Management",
      "site_master_planning": "Site Master Planning",
      "assisted_living_housekeeping_and_laundry": "Housekeeping And Laundry",
      "assisted_living_meal_services": "Meal Services",
      "assisted_living_memory_care": "Memory Care",
      "assisted_living_other": "Other",
      "assisted_living_rehabilitation_services": "Rehabilitation Services",
      "assisted_living_transportation": "Transportation",
      "assisted_living_wellness_programs": "Wellness Programs",
      "daily_living_assistance": "Daily Living Assistance",
      "medication_management": "Medication Management",
      "short_term_stays": "Short Term Stays",
      "social_and_recreational_activities": "Recreational Activites",
      "babysitter_other": "Other",
      "event_babysitting": "Event Babysitting",
      "homework_assistance": "Homework Assistance",
      "housekeeping_laundry": "Housekeeping And Laundry",
      "meal_preparation": "Meal Preparation",
      "nanny_services": "Nanny Services",
      "overnight_babysitting": "Overnight Babysitting",
      "pick_up_and_drop_off": "Pick Up And Drop Off",
      "shopping_errand": "Shopping And Errand",
      "special_needs_care": "Special Needs Care",
      "virtual_babysitting": "Virtual Babysitting",
      "agriculture_bankruptcy": "Agriculture Bankruptcy",
      "bankruptcy_lawyer_other": "Other",
      "bankruptcy_litigation": "Bankruptcy Litigation",
      "chapter_11_bankruptcy": "Chapter 11 Bankruptcy",
      "chapter_13_bankruptcy": "Chapter 13 Bankruptcy",
      "chapter_7_bankruptcy": "Chapter 7 Bankruptcy",
      "corporate_bankruptcy": "Corporate Bankruptcy",
      "creditor_harassment": "Creditor Harassment",
      "debt_settlement": "Debt Settlement",
      "foreclosure_bankruptcy_lawyer": "Foreclosure",
      "personal_bankruptcy": "Personal Bankruptcy",
      "repossession": "Repossession",
      "wage_garnishment": "Wage Garnishment",
      "beauty_school_barbering": "Barbering",
      "beauty_school_business_management": "Business Management",
      "beauty_school_cosmetology": "Cosmetology",
      "beauty_school_esthetics": "Esthetics",
      "beauty_school_hair_cutting": "Hair Cutting",
      "beauty_school_hair_design": "Hair Design",
      "beauty_school_makeup": "Makeup",
      "beauty_school_massage_therapy": "Massage Therapy",
      "beauty_school_nail_technology": "Nail Technology",
      "beauty_school_other": "Other",
      "beauty_school_retail_training": "Retail Training",
      "banking_finance_law": "Banking & Finance",
      "business_lawyer_other": "Other",
      "business_licenses_permits": "Business Licenses & Permits",
      "business_litigation": "Business Litigation",
      "business_taxes": "Business Taxes",
      "business_transactions_business_lawyer": "Business Transactions",
      "commercial_bankruptcy": "Commercial Bankruptcy",
      "commercial_contracts_business_lawyer": "Commercial Contracts",
      "employment_law_business_lawyer": "Employment Law",
      "incorporation_restructuring": "Incorporation & Restructuring",
      "insurance_law": "Insurance Law",
      "intellectual_property_law": "Intellectual Property Law",
      "mergers_acquisitions_business_lawyer": "Mergers & Acquisitions",
      "partnership_agreements_business_lawyer": "Partnership Agreements",
      "patents_copyrights_trademarks": "Patents, Copyrights, & Trademarks",
      "securities_law": "Securities Law",
      "shareholder_disputes": "Shareholder Disputes",
      "air_and_cabin_filter": "Air & Cabin Filter",
      "battery": "Battery",
      "body_and_trim": "Body & Trim",
      "brakes": "Brakes",
      "car_air_conditioning": "Air Conditioning",
      "car_electrical": "Electrical",
      "car_repair_other": "Other",
      "check_engine_light_diagnostic": "Check Engine Light Diagnostic",
      "exhaust": "Exhaust",
      "oil_change": "Oil Change",
      "steering_suspension": "Steering / Suspension",
      "tires": "Tires",
      "transmission": "Transmission",
      "cabinetry": "Cabinetry",
      "carpenter_other": "Other",
      "decking": "Decking",
      "drywalling": "Drywalling",
      "fencing": "Fencing",
      "general_installations": "General Installations",
      "general_repairs_maintenance": "General Repairs & Maintenance",
      "remodeling": "Remodeling",
      "shelving_storage": "Shelving & Storage",
      "carpet_cleaning_other": "Other",
      "clean_area_rugs": "Clean Area Rugs",
      "clean_carpet": "Clean Carpet",
      "clean_drapes_and_curtains": "Clean Drapes & Curtains",
      "clean_upholstery": "Clean Upholstery",
      "remove_pet_stains_and_odors": "Remove Pet Stains & Odors",
      "after_school_care": "After School Care",
      "all_hours_daycare": "All Hours Daycare",
      "bilingual_daycare": "Bilingual Daycare",
      "child_care_other": "Other",
      "drop_in_daycare": "Drop-in Daycare",
      "full_time_daycare": "Full-time Daycare",
      "in_home_daycare": "In-home Daycare",
      "infant_programs": "Infant Programs",
      "part_time_daycare": "Part-time Daycare",
      "pre_kindergarten_programs": "Pre-kindergarten Programs",
      "preschool_programs": "Preschool Programs",
      "school_age_programs": "School-age Programs",
      "special_needs_daycare": "Special Needs Daycare",
      "summer_daycare": "Summer Daycare",
      "toddler_programs": "Toddler Programs",
      "weekend_daycare": "Weekend Daycare",
      "chiropractor_acupuncture": "Acupuncture",
      "chiropractor_chiropractic": "Chiropractic",
      "chiropractor_massage_therapy": "Massage Therapy",
      "chiropractor_other": "Other",
      "diagnosis": "Diagnosis",
      "eastern_medicine": "Eastern Medicine",
      "exercise_counseling": "Exercise Counseling",
      "pain_management": "Pain Management",
      "physical_therapy": "Physical Therapy",
      "spinal_adjustments": "Spinal Adjustments",
      "sports_medicine": "Sports Medicine",
      "cleaner_other": "Other",
      "deep_clean": "Deep Clean",
      "moving_clean": "Moving Clean",
      "office_clean": "Office Clean",
      "standard_clean": "Standard Clean",
      "assignment_of_contract": "Assignment Of Contract",
      "business_transactions_contract_lawyer": "Business Transactions",
      "commercial_contracts_contract_lawyer": "Commercial Contracts",
      "contract_dispute": "Contract Dispute",
      "contract_lawyer_other": "Other",
      "contract_negotiation": "Contract Negotiation",
      "contract_review": "Contract Review",
      "employment_contracts_contract_lawyer": "Employment Contracts",
      "franchise_agreements": "Franchise Agreements",
      "mergers_acquisitions_contract_lawyer": "Mergers & Acquisitions",
      "non_disclosure_agreements_contract_lawyer": "Non-disclosure Agreements",
      "partnership_agreements_contract_lawyer": "Partnership Agreements",
      "power_of_attorney_contract_lawyer": "Power Of Attorney",
      "security_agreements": "Security Agreements",
      "warranties": "Warranties",
      "bathroom_countertops": "Bathroom Countertops",
      "bathroom_wall_panels": "Bathroom Wall Panels",
      "countertop_design": "Countertop Design",
      "countertop_installation": "Countertop Installation",
      "countertop_pro_other": "Other",
      "fireplace_facade": "Fireplace Facade",
      "granite_countertops": "Granite Countertops",
      "kitchen_countertops": "Kitchen Countertops",
      "kitchen_wall_panels": "Kitchen Wall Panels",
      "laminate_countertops": "Laminate Countertops",
      "marble_countertops": "Marble Countertops",
      "quartz_countertops": "Quartz Countertops",
      "remodeling_countertop_pro": "Remodeling",
      "repair_maintenance_countertop_pro": "Repair & Maintenance",
      "stone_slab_countertops": "Stone Slab Countertops",
      "tile_countertops": "Tile Countertops",
      "corporate_representation": "Corporate Representation",
      "criminal_immigration_defense": "Criminal Immigration Defense",
      "criminal_lawyer_other": "Other",
      "domestic_violence": "Domestic Violence",
      "drug_possession": "Drug Possession",
      "duis_reckless_driving": "DUIs & Reckless Driving",
      "expungement": "Expungement",
      "federal_crimes": "Federal Crimes",
      "felonies": "Felonies",
      "petty_crimes_misdemeanors": "Petty Crimes & Misdemeanors",
      "restraining_orders": "Restraining Orders",
      "sex_offenses": "Sex Offenses",
      "three_strikes_law": "Three-strikes Law",
      "dance_instructor_african": "African",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Ballroom",
      "dance_instructor_belly": "Belly",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Contemporary",
      "dance_instructor_folk_traditional": "Folk And Traditional",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Kids' Classes",
      "dance_instructor_latin": "Latin",
      "dance_instructor_modern": "Modern",
      "dance_instructor_other": "Other",
      "dance_instructor_tap": "Tap",
      "dance_instructor_wedding": "Wedding",
      "disability_hearings": "Disability Hearings",
      "disability_lawyer_other": "Other",
      "long_term_disability": "Long-term Disability",
      "short_term_disability": "Short-term Disability",
      "social_security_disability_insurance": "Social Security Disability Insurance",
      "ssa_claim_reconsideration": "SSA Claim Reconsideration",
      "ssa_disability_appeals": "SSA Disability Appeals",
      "ssa_disability_applications": "SSA Disability Applications",
      "ssa_disability_benefits": "SSA Disability Benefits",
      "ssa_family_benefits": "SSA Family Benefits",
      "ssa_impairment_listings": "SSA Impairment Listings",
      "supplemental_security_income": "Supplemental Security Income",
      "veterans_disability_benefits": "Veterans Disability Benefits",
      "workers_compensation_disability_lawyer": "Workers' Compensation",
      "behind_the_wheel_lessons": "Behind The Wheel Lessons",
      "commercial_license_training": "Commercial License Training",
      "defensive_driving_lessons": "Defensive Driving Lessons",
      "drivers_education_classes": "Drivers Education Classes",
      "driving_instructor_other": "Other",
      "manual_transmission_lessons": "Manual Transmission Lessons",
      "motorcycle_lessons": "Motorcycle Lessons",
      "traffic_school": "Traffic School",
      "dui_dwi_dui_lawyer": "DUI/DWI",
      "dui_injuries_dui_lawyer": "DUI With Injury",
      "dui_lawyer_other": "Other",
      "dui_with_accident": "DUI With Accident",
      "felony_dui": "Felony DUI",
      "invalid_tests": "Invalid Tests",
      "multiple_offenses": "Multiple Offenses",
      "reckless_driving_dui_lawyer": "Reckless Driving",
      "underage_dui": "Underage DUI",
      "electric_car_charger": "Install Electric Car Charger",
      "electrician_other": "Other",
      "electrician_remodeling": "Remodeling",
      "install_fan": "Install Fan",
      "install_ground_wire": "Install Ground Wire",
      "install_light_fixtures": "Install Light Fixtures",
      "install_outdoor_lighting": "Install Outdoor Lighting",
      "install_outlets_switches": "Install Outlets Or Switches",
      "install_security_system": "Install Security System",
      "relocate_outlets_switches": "Relocate Outlets Or Switches",
      "repair_fan": "Repair Fan",
      "repair_light_fixtures": "Repair Light Fixtures",
      "repair_outlets_switches": "Repair Outlets Or Switches",
      "repair_panel": "Repair Panel",
      "replace_upgrade_panel": "Replace Or Upgrade Panel",
      "restore_power": "Restore Power",
      "energy_efficiency_pro_other": "Other",
      "charitable_giving": "Charitable Giving",
      "contests_litigation": "Contests / Litigation",
      "deeds": "Deeds",
      "estate_lawyer_other": "Other",
      "estate_planning_lawyer": "Estate Planning",
      "guardianship_estate_lawyer": "Guardianship",
      "medical_power_of_attorney": "Medical Power Of Attorney",
      "power_of_attorney_estate_lawyer": "Power Of Attorney",
      "probate_estate_lawyer": "Probate Estate Lawyer",
      "trusts": "Trusts",
      "wills": "Wills",
      "anniversary_planner": "Anniversary",
      "baby_shower_planner": "Baby Shower",
      "bar_and_bat_mitzvah_planner": "Bar And Bat Mitzvah",
      "birthday_party": "Birthday Party",
      "children_party": "Children's Party",
      "corporate_and_conference_planner": "Corporate And Conference",
      "event_planner_other": "Other",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religious Event",
      "retirement_party": "Retirement Party",
      "school_event": "School Event",
      "theme_party": "Theme Party",
      "wedding_and_engagement_planner": "Wedding And Engagement",
      "adoption": "Adoption",
      "child_support": "Child Support",
      "contested_divorce": "Contested Divorce",
      "debt_division": "Debt Division",
      "family_lawyer_other": "Other",
      "guardianship_family_lawyer": "Guardianship",
      "mediation_family_lawyer": "Mediation",
      "modifications_of_orders": "Modification Of Orders",
      "parent_timesharing": "Parent Timesharing",
      "paternity": "Paternity",
      "prenuptial_postnuptial_agreements": "Prenups & Marital Agreements",
      "probate_family_lawyer": "Probate",
      "property_divisions": "Property Division",
      "protective_orders_domestic_violence_issues": "Restraining Orders",
      "spousal_support_alimony": "Spousal Support & Alimony",
      "uncontested_divorce": "Uncontested Divorce",
      "custom_construction": "Custom Construction",
      "fence_design": "Fence Design",
      "fencing_other": "Other",
      "installation_fencing_pro": "Fence Installation",
      "repairs_maintenance_fencing_pro": "Repairs & Maintenance",
      "education_savings": "Education Savings",
      "estate_financial_planning": "Estate Planning",
      "financial_planning": "Financial Planning",
      "financial_planning_other": "Other",
      "home_purchase": "Home Purchase",
      "insurance": "Insurance",
      "investment_advising": "Investment Advising",
      "retirement_savings": "Retirement",
      "tax_planning": "Tax Planning",
      "advanced_cardiac_life_support": "Advanced Cardiac Life Support",
      "aed_defibrillator": "AED - Defibrillator",
      "basic_life_support": "Basic Life Support",
      "cpr": "CPR",
      "first_aid": "First Aid",
      "first_aid_trainer_other": "Other",
      "pediatric_advanced_life_support": "Pediatric Advanced Life Support",
      "pediatric_cpr_first_aid": "Pediatric CPR And First Aid",
      "pet_cpr_first_aid": "Pet CPR And First Aid",
      "wilderness_first_aid": "Wilderness First Aid",
      "baseboards": "Baseboards",
      "carpet": "Carpet",
      "flooring_other": "Other",
      "hardwood": "Hardwood",
      "installation_flooring_pro": "Installing Floors",
      "marble": "Marble",
      "polishing": "Floor Polishing",
      "refinishing": "Floor Refinishing",
      "repair_maintenance_flooring_pro": "Floor Repair & Maintenance",
      "stair_flooring": "Stair Flooring",
      "tile": "Tile",
      "wood_floor_sanding": "Wood Floor Sanding",
      "basement_waterproofing": "Basement Waterproofing",
      "crawl_spaces": "Crawl Space Foundation",
      "foundation_drainage": "Foundation Drainage",
      "foundation_installation": "Foundation Installation",
      "foundation_pro_other": "Other",
      "foundation_raising": "Foundation Raising",
      "repairs_maintenance_foundation_pro": "Repairs & Maintenance",
      "slab_foundation": "Slab Foundation",
      "steel_pier_pilings": "Steel Pier Pilings",
      "water_moisture_control": "Water & Moisture Control",
      "burials": "Burials",
      "caskets": "Caskets",
      "cremation": "Cremation",
      "funeral_home_flowers": "Flowers",
      "funeral_home_other": "Other",
      "funeral_home_transportation_transfers": "Transportation And Transfers",
      "funeral_home_veteran_services": "Veteran Services",
      "funerals": "Funerals",
      "gravestones": "Gravestones",
      "grief_services": "Grief Services",
      "memorials": "Memorials",
      "urns": "Urns",
      "garage_door_other": "Other",
      "general_maintenance": "General Maintenance",
      "install_garage_door": "Install Garage Door",
      "install_opener": "Install Opener",
      "repair_cables": "Repair Cables",
      "repair_garage_door": "Repair Garage Door",
      "repair_gate": "Repair Gate",
      "repair_rollers_tracks": "Repair Rollers And Tracks",
      "replace_door_panels": "Replace Door Panels",
      "replace_opener": "Replace Opener",
      "replace_springs": "Replace Springs",
      "accessory_buildings": "Accessory Buildings",
      "bathroom_remodel": "Bathroom Remodel",
      "decks_patio": "Decks And Patio",
      "exterior_finishing": "Exterior Finishing",
      "foundations_concrete": "Foundations And Concrete",
      "general_contractor_commercial_projects": "Commercial Projects",
      "general_contractor_other": "Other",
      "home_addition": "Home Addition",
      "home_building": "Home Building",
      "home_remodel_renovation": "Home Remodel And Renovation",
      "interior_finishing": "Interior Finishing",
      "kitchen_remodel": "Kitchen Remodel",
      "roofing": "Roofing",
      "assemble_furniture": "Assemble Furniture",
      "clean_gutters": "Clean Gutters",
      "handyman_other": "Other",
      "install_drywall": "Install Drywall",
      "install_flooring": "Install Flooring",
      "install_tile": "Install Tile",
      "install_water_fixtures": "Install Water Fixtures",
      "mount_tv": "Mount TV",
      "paint_indoors": "Paint Indoors",
      "paint_outdoors": "Paint Outdoors",
      "repair_drywall": "Repair Drywall",
      "repair_flooring": "Repair Flooring",
      "repair_water_fixtures": "Repair Water Fixtures",
      "replace_tile": "Replace Tile",
      "buyer_seller_inspection": "Buyer Seller Inspection",
      "commercial_properties": "Commercial Properties",
      "fire_safety": "Fire Safety",
      "fireplace_chimney": "Fireplace And Chimney",
      "full_home_inspection": "Full Home Inspection",
      "home_inspector_electrical": "Electrical",
      "home_inspector_foundation": "Foundation",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Mold",
      "home_inspector_new_construction": "New Construction",
      "home_inspector_other": "Other",
      "home_inspector_plumbing": "Plumbing",
      "home_inspector_roof": "Roof",
      "home_inspector_structural": "Structural",
      "home_warranty": "Home Warranty",
      "water_testing": "Water Testing",
      "well_or_septic_system": "Well Or Septic System",
      "wood_insects": "Wood And Insects",
      "access_control": "Access Control",
      "alarm_systems": "Alarm Systems",
      "commercial_security_systems": "Commercial Security Systems",
      "fire_smoke_detection": "Fire And Smoke Detection",
      "home_security_doors": "Doors",
      "home_security_locks": "Locks",
      "home_security_other": "Other",
      "home_security_windows": "Windows",
      "monitoring_services": "Monitoring Services",
      "residential_security_systems": "Residential Security Systems",
      "smart_home_integration": "Smart Home Integration",
      "video_surveillance": "Video Surveillance",
      "audio_video_installation": "Audio Video Installation",
      "commercial_projects": "Commercial Projects",
      "home_theater_design": "Home Theater Design",
      "home_theater_lighting": "Lighting",
      "home_theater_other": "Other",
      "home_theater_smart_home_integration": "Smart Home Integration",
      "install_tv": "Install TV",
      "network_it_services": "Network And IT Services",
      "outdoor_installations": "Outdoor Installations",
      "soundproofing": "Soundproofing",
      "whole_house_audio_video": "Whole House Audio Video",
      "ac_maintenance": "AC Maintenance",
      "clean_ducts_vents": "Clean Ducts & Vents",
      "ductless_heating_and_ac_services": "Ductless Heating And AC Services",
      "heating_maintenance": "Heating Maintenance",
      "hvac_maintenance": "HVAC Maintenance",
      "hvac_other": "Other",
      "install_ac": "Install AC",
      "install_ducts_vents": "Install Ducts & Vents",
      "install_heating_system": "Install Heating System",
      "install_thermostat": "Install Thermostat",
      "repair_ac": "Repair AC",
      "repair_ducts_vents": "Repair Ducts & Vents",
      "repair_heating_system": "Repair Heating System",
      "repair_hvac": "Repair HVAC",
      "repair_thermostat": "Repair Thermostat",
      "asylum": "Asylum",
      "citizenship": "Citizenship",
      "deportation": "Deportation",
      "family_based_immigration": "Family-based Immigration",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Other",
      "investment_visa": "Investment Visa",
      "outbound_work_permits": "Outbound Work Permits",
      "student_visa": "Student Visa",
      "visitor_visa": "Visitor Visa",
      "work_visa": "Work Visa",
      "appliance_selection": "Appliance Selection",
      "cabinetry_molding_hardware_design": "Cabinetry & Hardware Design",
      "decorating": "Decorating",
      "door_design": "Door Design",
      "exterior_building_design": "Exterior Building Design",
      "flooring_selection": "Flooring Selection",
      "interior_designer_other": "Other",
      "landscaping_design": "Landscaping Design",
      "lighting_design": "Lighting Design",
      "multifamily_housing_design": "Multifamily Housing Design",
      "room_planning": "Room Planning",
      "stone_brick_stucco_design": "Stone, Brick, & Stucco Design",
      "window_design": "Window Design",
      "advertisements": "Advertisements",
      "copyright": "Copyright",
      "export_control": "Export Control",
      "franchises": "Franchises",
      "international_ip": "International IP",
      "ip_lawyer_other": "Other",
      "ip_strategy": "IP Strategy",
      "ip_transactions": "IP Transactions",
      "licensing": "Licensing",
      "litigation_ip_lawyer": "Litigation",
      "non_disclosure_agreements_ip_lawyer": "Non-disclosure Agreements",
      "patents": "Patents",
      "technology_transfer": "Technology Transfer",
      "trade_secrets": "Trade Secrets",
      "trademarks": "Trademarks",
      "appliance_removal": "Appliance Removal",
      "construction_waste_removal": "Construction Waste Removal",
      "donation_pickup": "Donation Pickup",
      "electronic_waste_removal": "Electronic Waste Removal",
      "furniture_removal": "Furniture Removal",
      "general_junk_removal": "General Junk Removal",
      "hazardous_waste_removal": "Hazardous Waste Removal",
      "house_garage_cleanout": "House/garage Cleanout",
      "junk_removal_other": "Other",
      "yard_waste_removal": "Yard Waste Removal",
      "employment_contracts_labor_lawyer": "Employment Contracts",
      "employment_law_labor_lawyer": "Employment Law",
      "exempt_employee_status": "Exempt Employee Status",
      "labor_law": "Labor Law",
      "labor_lawyer_other": "Other",
      "labor_negotiations": "Labor Negotiations",
      "privacy_rights": "Privacy Rights",
      "sexual_harassment": "Sexual Harassment",
      "unpaid_overtime": "Unpaid Overtime",
      "whistle_blowing": "Whistle Blowing",
      "workers_compensation_labor_lawyer": "Workers' Compensation",
      "wrongful_termination": "Wrongful Termination",
      "artificial_turf_installation": "Artificial Turf Installation",
      "concrete_masonry": "Concrete Masonry",
      "driveway_landscaping": "Driveway Landscaping",
      "garden_decorations": "Garden Decorations",
      "grading_resloping": "Grading & Resloping",
      "hardscapes": "Hardscapes",
      "landscape_design": "Landscape Design",
      "landscape_installations": "Landscape Installations",
      "landscaper_other": "Other",
      "outdoor_steps": "Outdoor Steps",
      "outdoor_water_feature": "Outdoor Water Features",
      "paving_driveway_walkway": "Driveway Or Walkway Paving",
      "retaining_walls": "Retaining Walls",
      "sidewalk_walkway_landscaping": "Walkway Landscaping",
      "sod_seeding": "Sod & Seeding",
      "stone_masonry": "Stone Masonry",
      "arabic": "Arabic",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebrew",
      "italian": "Italian",
      "japanese": "Japanese",
      "korean": "Korean",
      "language_instructor_other": "Other",
      "mandarin": "Mandarin",
      "portuguese": "Portuguese",
      "russian": "Russian",
      "sign_language": "Sign Language",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Irrigation System Repair / Maintenance",
      "lawn_care_other": "Other",
      "lawn_mowing_maintenance": "Lawn Mowing / Maintenance",
      "lawn_pest_control": "Lawn Pest Control",
      "mulching": "Mulching",
      "seeding": "Seeding",
      "sod_installation": "Sod Installation",
      "weed_control": "Weed Control",
      "yard_cleanup": "Yard Cleanup",
      "appeals": "Appeals",
      "case_assessment_litigation_lawyer": "Case Assessment",
      "civil_litigation": "Civil Litigation",
      "commercial_litigation": "Commercial Litigation",
      "contracts_and_agreements": "Contracts And Agreements",
      "criminal_litigation": "Criminal Litigation",
      "litigation_lawyer_other": "Other",
      "mediation_litigation_lawyer": "Mediation",
      "settlements": "Settlements",
      "building_lockout": "Building Lockout",
      "copy_building_key": "Copy Building Keys",
      "copy_vehicle_key": "Copy Vehicle Key",
      "install_hardware": "Install Hardware",
      "locksmith_other": "Other",
      "new_key_fob": "New Key Fob",
      "rekey_lock": "Re-key Lock",
      "repair_hardware": "Repair Hardware",
      "vehicle_lockout": "Vehicle Lockout",
      "consent_issues": "Consent Issues",
      "diagnosis_errors": "Diagnosis Errors",
      "malpractice_lawyer_other": "Other",
      "medical_negligence": "Medical Negligence",
      "treatment_errors": "Treatment Errors",
      "massage_center_other": "Other",
      "massage_school_advanced_neuromuscular_therapy": "Advanced Neuromuscular Therapy",
      "massage_school_business_and_ethics": "Business And Ethics",
      "massage_school_clinical_therapies": "Clinical Therapies",
      "massage_school_continuing_education": "Continuing Education",
      "massage_school_deep_tissue_massage": "Deep Tissue Massage",
      "massage_school_energetics": "Energetics",
      "massage_school_hydrotherapy": "Hydrotherapy",
      "massage_school_lymphatic_massage": "Lymphatic Massage",
      "massage_school_online_massage_therapy": "Online Massage Therapy",
      "massage_school_other": "Other",
      "massage_school_prenatal_massage": "Prenatal Massage",
      "massage_school_sports_massage": "Sports Massage",
      "massage_school_student_massage_clinic": "Student Massage Clinic",
      "massage_school_swedish_massage": "Swedish Massage",
      "massage_theory": "Massage Theory",
      "massage_therapy_training": "Massage Therapy Training",
      "in_state_move": "In-state Move",
      "local_move": "Local Move",
      "mover_other": "Other",
      "moving_junk_removal": "Junk Removal",
      "moving_storage": "Storage",
      "out_of_state_move": "Out-of-state Move",
      "oversized_item_move": "Oversized Item Move",
      "packing_unpacking": "Packing / Unpacking",
      "senior_move": "Senior Move",
      "vehicle_transport": "Vehicle Transport",
      "cardiac_care": "Cardiac Care",
      "general_medical_care": "General Medical Care",
      "hospice": "Hospice",
      "iv_therapy": "IV Therapy",
      "nursing_home_meal_services": "Meal Servics",
      "nursing_home_memory_care": "Memory Care",
      "nursing_home_other": "Other",
      "nursing_home_pain_management": "Pain Management",
      "nursing_home_rehabilitation_services": "Rehabilitation Services",
      "nursing_home_wellness_programs": "Wellness Programs",
      "outpatient_rehabilitation": "Outpatient Rehabilitation",
      "post_hospital_care": "Post-hospital Care",
      "respiratory_and_pulmonary_care": "Respiratory And Pulmonary Care",
      "senior_activity_programs": "Senior Activity Programs",
      "short_term_rehabilitation": "Short-term Rehabilitation",
      "wound_care": "Wound Care",
      "exterior_painting": "Exterior Painting",
      "interior_painting": "Interior Painting",
      "paint_cabinets": "Paint Cabinets",
      "paint_doors": "Paint Doors",
      "painter_other": "Other",
      "repair_water_damage": "Repair Water Damage",
      "staining": "Staining",
      "assault_battery": "Assault & Battery",
      "auto_accidents": "Auto Accidents",
      "bicycle_accidents": "Bicycle Accidents",
      "catastrophic_injuries": "Catastrophic Injuries",
      "dog_bites": "Dog Bites",
      "dui_injuries_personal_injury_lawyer": "Injuries From DUI",
      "medical_malpractice": "Medical Malpractice",
      "motorcycle_accidents": "Motorcycle Accidents",
      "pain_suffering": "Pain & Suffering",
      "pedestrian_accidents": "Pedestrian Accidents",
      "personal_injury_lawyer_other": "Other",
      "product_liability": "Product Liability",
      "slip_fall": "Slip & Fall",
      "uninsured_motorist_claims": "Motorist Insurance Claims",
      "workers_compensation_personal_injury_lawyer": "Workers' Compensation",
      "wrongful_death": "Wrongful Death",
      "aerobics": "Aerobics",
      "athletic_performance": "Athletic Performance",
      "circuit_training": "Circuit Training",
      "endurance": "Endurance",
      "fitness_assessment": "Fitness Assessment",
      "hiit": "HIIT",
      "nutritional_counseling": "Nutritional Counseling",
      "personal_trainer_other": "Other",
      "strength_conditioning": "Strength And Conditioning",
      "weight_loss": "Weight Loss",
      "yoga": "Yoga",
      "ants": "Ants",
      "bed_bugs": "Bed Bugs",
      "bees": "Bees",
      "cockroaches": "Cockroaches",
      "fleas_or_mites": "Fleas Or Mites",
      "hornets_or_wasps": "Hornets Or Wasps",
      "mosquitoes": "Mosquitoes",
      "pest_control_other": "Other",
      "pest_inspection": "Inspection",
      "rodents": "Rodents",
      "spiders": "Spiders",
      "termites": "Termites",
      "wildlife": "Wildlife",
      "pet_adoption_birds": "Birds",
      "pet_adoption_cats": "Cats",
      "pet_adoption_dogs": "Dogs",
      "pet_adoption_farm_animals": "Farm Animals",
      "pet_adoption_fish": "Fish",
      "pet_adoption_other": "Other",
      "pet_adoption_reptiles": "Reptiles",
      "pet_adoption_small_mammals": "Small Mammals",
      "pet_adoption_special_needs_animals": "Special Needs Animals",
      "cat_boarding": "Cat Boarding",
      "cat_grooming": "Cat Grooming",
      "cat_sitting_in_home": "Cat Sitting (in-home)",
      "dog_boarding": "Dog Boarding",
      "dog_boarding_with_training": "Dog Boarding With Training",
      "dog_daycare": "Dog Daycare",
      "dog_grooming": "Dog Grooming",
      "dog_sitting_in_home": "Dog Sitting (in-home)",
      "dog_training": "Dog Training",
      "dog_walking": "Dog Walking",
      "other_pet_boarding": "Other Pet Boarding",
      "other_pet_daycare": "Other Pet Daycare",
      "other_pet_grooming": "Other Pet Grooming",
      "other_pet_sitting_in_home": "Other Pet Sitting (in-home)",
      "pet_boarding_other": "Other",
      "cat_bathing": "Cat Bathing",
      "cat_ear_cleaning": "Cat Ear Cleaning",
      "cat_grooming_and_styling": "Cat Grooming And Styling",
      "cat_nail_trimming": "Cat Nail Trimming",
      "dog_anal_gland_expression": "Dog Anal Gland Expression",
      "dog_bathing_and_blow_dry": "Dog Bathing And Blow Dry",
      "dog_ear_cleaning": "Dog Ear Cleaning",
      "dog_flea_and_tick_treatment": "Dog Flea And Tick Treatment",
      "dog_full_service_grooming": "Dog Full Service Grooming",
      "dog_grooming_and_styling": "Dog Grooming And Styling",
      "dog_nail_trimming": "Dog Nail Trimming",
      "dog_teeth_brushing": "Dog Teeth Cleaning",
      "pet_grooming_other": "Other",
      "aggressive_dog_training": "Aggressive Dog Training",
      "behavior_modification": "Behavior Modification",
      "obedience_training": "Obedience Training",
      "offleash_training": "Off-leash Training",
      "pet_trainer_other": "Other",
      "puppy_training": "Puppy Training",
      "service_animal_training": "Service Animal Training",
      "sport_trick_training": "Sport Or Trick Training",
      "training_other_animals": "Training For Other Animals",
      "corporate_photo": "Corporate",
      "events_and_parties_photo": "Events And Parties",
      "family_and_group_photo": "Family And Group",
      "headshots_and_portraits": "Headshots And Portraits",
      "individual_photo": "Individual",
      "maternity_and_newborn_photo": "Maternity And Newborn",
      "photographer_other": "Other",
      "product_photo": "Product",
      "real_estate_photo": "Real Estate",
      "school_portraits": "School Portraits",
      "wedding_and_engagement_photo": "Wedding And Engagement",
      "find_leak": "Find & Repair Leak",
      "install_faucet": "Install Faucet",
      "install_garbage_disposal": "Install Garbage Disposal",
      "install_shower": "Install Shower",
      "install_toilet": "Install Toilet",
      "install_water_heater": "Install Water Heater",
      "plumbing_other": "Other",
      "repair_faucet": "Repair Faucet",
      "repair_garbage_disposal": "Repair Garbage Disposal",
      "repair_outdoor_systems": "Repair Outdoor Systems",
      "repair_pipe": "Repair Pipe",
      "repair_sewer": "Repair Sewer",
      "repair_shower": "Repair Shower",
      "repair_toilet": "Repair Toilet",
      "repair_water_heater": "Repair Water Heater",
      "unclog_drain": "Unclog Drain",
      "commercial_pool_cleaning_maintenance": "Commercial Pool Cleaning And Maintenance",
      "equipment_maintenance_repair": "Equipment Maintenance Repair",
      "one_time_pool_cleaning": "One Time Pool Cleaning",
      "ongoing_pool_cleaning": "Ongoing Pool Cleaning",
      "pool_cleaner_other": "Other",
      "pool_cleaner_water_features": "Water Features",
      "seasonal_opening_closing": "Seasonal Opening And Closing",
      "spa_hot_tub_cleaning": "Spa And Hot Tub Cleaning",
      "spa_hot_tub_repairs": "Spa And Hot Tub Repairs",
      "tile_pool_wall_cleaning": "Tile And Pool Wall Cleaning",
      "water_testing_balancing": "Water Testing And Balancing",
      "jetted_lap_pools": "Jetted Lap Pools",
      "pool_construction": "Pool Construction",
      "pool_contractor_commercial_projects": "Commercial Projects",
      "pool_contractor_custom_designs": "Custom Designs",
      "pool_contractor_other": "Other",
      "pool_contractor_renovation": "Renovation",
      "pool_contractor_repair_cracks": "Repair Cracks",
      "pool_contractor_repair_tile": "Repair Tile",
      "pool_contractor_resurfacing": "Resurfacing",
      "pool_contractor_water_features": "Water Features",
      "pool_hot_tub_equipment": "Pool And Hot Tub Equipment",
      "spa_hot_tub_installation": "Spa And Hot Tub Installation",
      "bilingual_programs": "Bilingual Programs",
      "early_preschool": "Early Preschool",
      "full_day_preschool": "Full-day Preschool",
      "half_day_preschool": "Half-day Preschool",
      "kindergarten_classes": "Kindergarten Classes",
      "montessori_programs": "Montessori Programs",
      "play_based_preschool": "Play-based Preschool",
      "preschool_infant_programs": "Infant Programs",
      "preschool_other": "Other",
      "reggio_emilia_preschool": "Reggio Emilia Preschool",
      "special_needs_programs": "Special Needs Programs",
      "summer_camp": "Summer Camp",
      "waldorf_preschool": "Waldorf Preschool",
      "psychologist_other": "Other",
      "buyer_agent": "Buyer's Agent",
      "first_time_home_buyer": "First Time Home Buyer",
      "foreclosed_properties": "Foreclosed Properties",
      "luxury_properties": "Luxury Properties",
      "new_construction": "New Construction",
      "property_management": "Property Management",
      "real_estate_agent_other": "Other",
      "relocation": "Relocation",
      "rentals": "Rentals",
      "sellers_agent": "Seller's Agent",
      "commercial_real_estate": "Commercial Real Estate",
      "easements": "Easements",
      "encroachment": "Encroachment",
      "foreclosure_real_esate_lawyer": "Foreclosure",
      "landlord_tenant_law": "Landlord & Tenant Law",
      "litigation_real_estate_lawyer": "Litigation",
      "mortgage_lending_law": "Mortgage & Lending Law",
      "neighbor_hoa_disputes": "Neighbor & HOA Disputes",
      "property_damage": "Property Damage",
      "purchase_agreements": "Purchase Agreements",
      "real_estate_contracts_transactions": "Real Estate Transactions",
      "real_estate_lawyer_other": "Other",
      "residential_real_estate": "Residential Real Estate",
      "title_services": "Title Services",
      "trespassing": "Trespassing",
      "rehab_other": "Other",
      "attic_venting": "Attic Venting",
      "gutter_installation": "Gutter Installation",
      "gutter_repair": "Gutter Repair",
      "roof_inspection": "Roof Inspection",
      "roof_installation": "Roof Installation",
      "roof_repair": "Roof Repair",
      "roofer_other": "Other",
      "skylight_installation": "Skylight Installation",
      "skylight_repair": "Skylight Repair",
      "storm_wind_damage_roof_repair": "Roof Damage Repair",
      "sewage_cleaning": "Cleaning",
      "sewage_excavation": "Excavation",
      "sewage_inspection": "Inspection",
      "sewage_installation": "Installation",
      "sewage_locating": "Locating",
      "sewage_maintenance_repairs": "Maintenance And Repairs",
      "sewage_pro_other": "Other",
      "sewage_pumping": "Pumping",
      "sewage_removal_demolition": "Removal Or Demolition",
      "remodeling_siding_pro": "Remodeling",
      "repair_maintenance_siding_pro": "Repair & Maintenance",
      "siding_installation": "Siding Installation",
      "siding_pro_other": "Other",
      "siding_removal": "Siding Removal",
      "smart_home_other": "Other",
      "commercial_snow_removal": "Commercial Snow Removal",
      "residential_plowing": "Residential Plowing",
      "residential_shoveling_blowing": "Residential Shoveling Blowing",
      "salt_sand_deicing": "Salt Sand And De-icing",
      "snow_relocation": "Snow Relocation",
      "snow_removal_other": "Other",
      "body_polish": "Body Polish",
      "body_wrap": "Body Wrap",
      "facial": "Facial",
      "hydrotherapy": "Hydrotherapy",
      "manicure": "Manicure",
      "massage": "Massage",
      "pedicure": "Pedicure",
      "peels": "Peels",
      "spa_other": "Other",
      "spa_packages": "Spa Packages",
      "tanning": "Tanning",
      "waxing": "Waxing",
      "civil_tax_litigation": "Civil Tax Litigation",
      "corporate_taxes": "Corporate Taxes",
      "criminal_tax_litigation": "Criminal Tax Litigation",
      "estate_tax_planning": "Estate Tax Planning",
      "failure_to_file": "Failure To File",
      "innocent_spouse_relief": "Innocent Spouse Relief",
      "international_tax_services": "International Tax Services",
      "irs_tax_problems": "IRS Tax Problems",
      "non_collectible_status": "Non-collectible Status",
      "offer_in_compromise": "Offer In Compromise",
      "tax_audits": "Tax Audits",
      "tax_lawyer_other": "Other",
      "tax_liens_levies": "Tax Liens & Levies",
      "tax_planning_lawyer": "Tax Planning",
      "tax_relief": "Tax Relief",
      "accounting_support": "Accounting Support",
      "business_incorporation_restructuring": "Incorporation & Restructuring",
      "cryptocurrency_taxes": "Cryptocurrency Taxes",
      "irs_audit_representation": "IRS Audit Representation",
      "irs_filing": "IRS Filing",
      "irs_problem_consulting": "IRS Problem Consulting",
      "new_business_services": "New Business Services",
      "payroll_support": "Payroll Support",
      "tax_planning_tax_specialist": "Tax Planning",
      "tax_preparation": "Tax Preparation",
      "tax_problem_consulting_tax_specialist": "Tax Problem Consulting",
      "tax_specialist_other": "Other",
      "therapist_other": "Other",
      "battery_service": "Battery Service",
      "car_towing": "Car Towing",
      "fuel_delivery": "Fuel Delivery",
      "local_hauling": "Local Hauling",
      "long_distance_hauling": "Long Distance Hauling",
      "motorcycle_towing": "Motorcycle Towing",
      "special_vehicle_towing": "Special Vehicle Towing",
      "tire_change": "Tire Change",
      "towing_other": "Other",
      "case_assessment_traffic_lawyer": "Case Assessment",
      "cdl_traffic_ticket": "CDL Traffic Ticket",
      "dui_dwi_traffic_lawyer": "DUI",
      "fixit_ticket": "Fix-it Ticket",
      "parking_ticket": "Parking Ticket",
      "reckless_driving_traffic_lawyer": "Reckless Driving",
      "red_light_ticket": "Red Light Ticket",
      "speeding_ticket": "Speeding Ticket",
      "suspended_license": "Suspended License",
      "traffic_lawyer_other": "Other",
      "traffic_ticket": "Traffic Ticket",
      "cabling_and_bracing": "Cabling And Bracing",
      "stump_removal": "Stump Removal",
      "tree_planting": "Tree Planting",
      "tree_removal": "Tree Removal",
      "tree_service_other": "Other",
      "tree_transplanting": "Tree Transplanting",
      "tree_trimming_and_pruning": "Tree Trimming And Pruning",
      "tutor_computer_science": "Computer Science",
      "tutor_foreign_languages": "Foreign Languages",
      "tutor_geography": "Geography",
      "tutor_government_and_economics": "Government & Economics",
      "tutor_history": "History",
      "tutor_homework_help": "Homework Help",
      "tutor_math": "Math",
      "tutor_other": "Other",
      "tutor_reading_and_writing": "Reading & Writing",
      "tutor_science": "Science",
      "tutor_special_education": "Special Education",
      "tutor_test_pre_college_entrance": "Test Prep: College Entrance",
      "tutor_test_prep_grad_school_entrance": "Test Prep: Grad School Entrance",
      "tutor_test_prep_k8": "Test Prep: K-8",
      "area_rug_cleaning": "Area Rug Cleaning",
      "drapery_and_blind_cleaning": "Drapery & Blind Cleaning",
      "leather_cleaning": "Leather Cleaning",
      "mattress_cleaning": "Mattress Cleaning",
      "upholstery_cleaner_other": "Other",
      "upholstery_cleaning": "Upholstery Cleaning",
      "upholstery_water_damage_cleanup": "Water Damage Cleanup",
      "bird_exotic_animal_care": "Bird And Exotic Animal Care",
      "farm_barn_animal_care": "Farm And Barn Animal Care",
      "microchipping": "Microchipping",
      "veterinarian_allergies": "Allergies",
      "veterinarian_behavior_counseling": "Behavior Counseling",
      "veterinarian_dental_care": "Dental Care",
      "veterinarian_dermatology": "Dermatology",
      "veterinarian_emergency_care": "Emergency Care",
      "veterinarian_end_of_life_care": "End Of Life Care",
      "veterinarian_examinations": "Examinations",
      "veterinarian_nutrition_counseling": "Nutrition Counseling",
      "veterinarian_other": "Other",
      "veterinarian_preventive_care": "Preventive Care",
      "veterinarian_spay_neuter": "Spay Or Neuter",
      "veterinarian_surgery": "Surgery",
      "veterinarian_vaccinations": "Vaccinations",
      "aerial_videography": "Aerial Videography",
      "documentary_video_production": "Documentary Production",
      "family_video_production": "Family Video Production",
      "live_streaming": "Live Streaming",
      "photography": "Photography",
      "product_demonstrations": "Product Demonstration",
      "promotional_video_production": "Promotional Video Production",
      "real_estate_video_production": "Real Estate Video Production",
      "special_event_video_production": "Special Event Video Production",
      "video_editing": "Video Editing",
      "videographer_other": "Other",
      "voice_overs": "Voice Over",
      "wedding_video_production": "Wedding Video Production",
      "fire_damage_cleanup_repair": "Fire Damage Cleanup/repair",
      "water_damage_cleanup_repair": "Water Damage Cleanup",
      "water_damage_flooring": "Flooring",
      "water_damage_mold_inspection": "Mold Inspection",
      "water_damage_mold_removal": "Mold Removal",
      "water_damage_other": "Other",
      "water_damage_painting": "Painting",
      "water_damage_pest_control": "Pest Control",
      "water_damage_plumbing": "Plumbing",
      "water_damage_remodeling": "Remodeling",
      "water_damage_roofing": "Roofing",
      "water_damage_sewage_cleanup": "Sewage Cleanup",
      "adult_weight_loss_programs": "Adult Weight Loss Programs",
      "diet_and_nutrition_counseling": "Diet And Nutrition Counseling",
      "kids_weight_loss_programs": "Kids Weight Loss Programs",
      "metabolic_testing": "Metabolic Testing",
      "weight_loss_consultation_and_training": "Consultation And Training",
      "weight_loss_fitness_programs": "Fitness Programs",
      "weight_loss_meal_planning": "Meal Planning",
      "weight_loss_personal_training": "Personal Training",
      "weight_loss_service_other": "Other",
      "weight_loss_wellness_programs": "Wellness Programs",
      "glass_and_mirror_cleaning": "Glass & Mirror Cleaning",
      "gutter_cleaning": "Gutter Cleaning",
      "power_pressure_washing": "Power/pressure Washing",
      "rooftop_skylight_cleaning": "Rooftop/skylight Cleaning",
      "window_cleaner_other": "Other",
      "window_cleaning": "Window Cleaning",
      "door_installation": "Door Installation",
      "door_repair": "Door Repair",
      "glass_installation": "Glass Installation",
      "window_boardup": "Boardup",
      "window_installation": "Window Installation",
      "window_repair": "Window Repair",
      "window_repair_other": "Other",
      "install_new_wiper_blades": "Install New Wiper Blades",
      "repair_power_window": "Repair Power Window",
      "repair_water_leak": "Repair Water Leak",
      "repair_windshield": "Repair Windshield",
      "replace_rear_window": "Replace Rear Window",
      "replace_side_view_mirrors": "Repair Side View Mirrors",
      "replace_side_window": "Replace Side Window",
      "replace_sunroof": "Replace Sunroof Glass",
      "replace_windshield": "Replace Windshield",
      "windshield_other": "Other",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot Yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditation",
      "power_yoga": "Power Yoga",
      "restorative": "Restorative",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Other"
    }
  }
}
